/* eslint-disable no-dupe-keys */
const English = {
  CreateAccount: {
    CREATE_ACC_DESC_1:
      "Sign up for Build Id, a free construction app that empowers and rewards tradespeople and other working in the industry.",
    CREATE_ACC_DESC_2:
      "Organize your safety tickets, generate professional-looking resumes, and connect with the construction industry.",
    TEXT_FIRST_NAME: "First Name",
    TEXT_LAST_NAME: "Last Name",
    TEXT_EMAIL: "Email",
    TEXT_PASSWORD: "Password",
    TEXT_PASS_STRENGTH: "Password strength",
    TEXT_STRONG_PASS: "Strong",
    TEXT_WEAK_PASS: "Weak",
    TEXT_CHARACTERS: "At least 6 characters",
    TEXT_NUMBER: "At least 1 number",
    TEXT_CAPITAL_LETTER: "At least 1 capital letter",
    TEXT_LOWER_LETTER: "At least 1 lowercase letter",
    BUTTON_CREATE_ACCOUNT: "Create Account"
  },
  Login: {
    TEXT_LOGIN: "Log in",
    TEXT_EMAIL: "Email",
    TEXT_PASSWORD: "Password",
    TEXT_FORGOT_PASSWORD: "Forgot Password?",
    TEXT_TAKE_A_TOUR: "Take A Tour",
    TEXT_CREATE_NEW_ACCOUNT: "Create New Account",
    TEXT_DESCIPTION_1:
      "Showcase the sites that you have been a part of that make you be proud of working in construction.",
    TEXT_DESCIPTION_2:
      "Earn BuilderBucks that you can exchange for chances to win prizes, tools, and other cool things!",
    SNACKBAR_RESET_PASSWORD: "Instructions to reset your password have been sent to your email.",
    TEXT_INVALID_EMAIL: "Please enter a valid email address.",
    TEXT_PASSWORD_CHANGED: "Password changed successfully"
  },
  TakeATour: {
    TEXT_TAKE_A_TOUR: "Take A Tour",
    TEXT_HEADING_TICKETS: "Manage safety tickets",
    TEXT_SUBHEADING_TICKETS:
      "Never lose or let a ticket expire—store, share, and add them to your resume all in one place.",
    TEXT_HEADING_CHAT: "Auto chat translation",
    TEXT_SUBHEADING_CHAT: "Live translation for conversations with builders in any language.",
    TEXT_HEADING_SITES: "Construction site map",
    TEXT_SUBHEADING_SITES: "Browse nearby construction sites on the map and view project info.",
    TEXT_HEADING_TIMESHEETS: "Create timesheets",
    TEXT_SUBHEADING_TIMESHEETS: "Log hours, check pay, and track progress toward your goals.",
    TEXT_HEADING_EXPENSES: "Record expenses",
    TEXT_SUBHEADING_EXPENSES: "Track and share purchases—no more lost receipts!",
    TEXT_HEADING_CARPOOL: "Find carpooling",
    TEXT_SUBHEADING_CARPOOL: "See who’s nearby on site and start a chat to set up a carpool.",
    BUTTON_GET_STARTED: "Get Started",
    BUTTON_SKIP: "Skip"
  },
  MainApp: {
    TEXT_PAGE_NOT_FOUND: "Page Not Found, Please GO Back"
  },
  Header: {
    TEXT_SEARCH_BUILDID_PLACEHOLDER: "Search BuildID",
    TEXT_CHAT: "Chat",
    TEXT_NOTIFICATIONS: "Notifications",
    TOP_BAR_MENU_HELP_CENTER: "Help Center",
    TEXT_MORE_MODAL_TUTORIAL: "Tutorial",
    BUTTON_REPORT: "Report"
  },

  NotificationsMenu: {
    TEXT_POINTS_GAINED: "Points gained", //
    TEXT_PROJECTS_ADDED: "Projects added",
    TEXT_PRODUCTS_ADDED: "Products added",
    TEXT_QUESTIONS_ANS: "Questions answered",
    TEXT_NUMBER_OF_VIEWS_PROFILE: "Number of views on profile",
    TEXT_NOTIFICATIONS: "Notifications",
    TEXT_CONTACT_REQUESTS: "Contact Requests",
    TEXT_ACCEPT: "Accept",
    TEXT_DISMISS: "Dismiss",
    TEXT_DISMISS_ALL: "Dismiss all",
    TEXT_NO_NOTIFICATIONS: "No notifications found",
    TEXT_AVAILABLE_TO_DISMISS: "Available to dismiss",
    TEXT_WEEKLY_SUMMARY: "Weekly Summary",
    TEXT_BUILDER_BUCKS: "BuilderBucks"
  },

  Sidebar: {
    TEXT_HOME: "Home",
    TEXT_SITES: "Sites",
    BUTTON_REWARDS_STORE: "Rewards Store",
    TEXT_MY_EXPERIENCE_HEADING: "My Experience",
    TEXT_TIMESHEETS: "Timesheets",
    TEXT_EXPENSES: "Expenses",
    RESUME_BUILDER: "Resume Builder",
    TEXT_TICKETS: "Tickets",
    TEXT_MONTAGES: "Montages",
    TEXT_COMMUNITY_HEADING: "Community",
    TEXT_BUILDER_NETWORK: "Builder Network",
    TEXT_CARPOOL: "Carpool",
    TEXT_JOB_POSTINGS: "Job Posting",
    TEXT_BUY_SELL: "BuySell",
    TEXT_MY_GROUPS: "My Groups",
    TEXT_COMPANIES: "Companies",
    TEXT_MANUFACTURERS: "Manufactures",
    TEXT_PRODUCTS: "Products",
    TEXT_TRADES_TITLE: "Trades",
    TEXT_PROJECTS: "Projects"
  },

  Profile: {
    TEXT_BUILDER_NETWORK: "Builder Network",
    TEXT_LOOK_FOR_PEOPPLE: "Look For People",
    TEXT_NO_CONTACT_PLACEHOLDER:
      "Connect with other BuildID users to build your professional network.",
    TEXT_SEE_ALL: "See All",
    TEXT_NO_MAIN_TRADE: "No Main Trade",
    TEXT_PROFILE_PICTURE: "Profile Picture",

    // NEW ABOVE

    // Profile.jsx
    TEXT_PLEASE_ENTER_NAME: "Please enter name",
    TEXT_DELETE_CONTACT: "Delete Contact",
    TEXT_JOINED: "Joined",
    TEXT_VIEW_MORE: "View More",
    TEXT_VIEW_LESS: "View Less",
    TEXT_CONNECT_SIMILAR_BID_USER: "Connect with similar BuildID users by adding your Trade(s)",
    BUTTON_ADD_MY_TRADE: "Add My Trade",
    TEXT_MESSAGE: "Message",
    BUTTON_CONNECT: "Connect",
    BUTTON_REQUESTED: "Requested",
    TEXT_ACCEPTCONTACT_BUTTON: "ACCEPT CONTACT",
    TEXT_BUILDER_NETWORK: "Builder Network",
    TEXT_ABOUT: "About",
    BUTTON_EDIT: "Edit",
    BUTTON_ADD_MY_ADDRESS: "Add My Address",
    TEXT_NO_MORE_INFORMATION: "No More Information",
    TEXT_CANCEL_REQUEST: "Cancel Request",
    TEXT_ALERT_CANCEL_REQUEST: "Are you sure you want to cancel this contact request?",
    TEXT_DELETE_CONTACT_CONF_TITLE: "Are you sure you want to delete this contact?",
    TEXT_DESC_CONFIRMATION: "This action cannot be undone.",
    TEXT_EMAIL_NEED_TO_VERIFIED: "This Email is still needs to be verified.",
    TEXT_PHONE_NEED_TO_VERIFIED: "This Phone Number is still needs to be verified.",
    TEXT_CONNECT_REQUEST: "Connect Request",
    TEXT_CONTACT_SUGGETION: "Suggested Connections",
    TEXT_REQUESTED_CONNECT_WITH_YOU: "has requested to Connect you.",
    TEXT_RIDE_SHARE_DESC:
      "Add an address to take advantage of the ride share opportunities in the BuildID community.",
    TEXT_TITLE_ROLE: "Title/Role",
    // Addcompany.jsx
    MODAL_DISCARD_TITLE: "Are you sure you want to leave?",
    DISCARD_MODAL_DESCRIPTION: "Any unsaved changes will be discarded.",
    BUTTON_DISCARD: "Discard",
    BUTTON_GOBACK: "Go Back",
    MODAL_DELETE_TITLE: "Are you sure you want to delete this company?",
    BUTTON_DELETE: "Delete",
    BUTTON_CANCEL: "Cancel",
    TEXT_EDIT_COMPANY_TO_PROFILE: "Edit Company to Profile",
    TEXT_ADD_COMPANY_TO_PROFILE: "Add Company to Profile",
    BUTTON_ADD: "Add",
    TEXT_COMPANY: "Company",
    TEXT_START_DATE: "Start Date",
    TEXT_END_DATE: "End Date",
    TEXT_PRESENT: "Present",
    TEXT_JOB_DESCRIPTION: "Job Description",
    TEXT_CURRENTLY_WORK_HERE:
      "or click I currently work here if you are still working on this site.",
    TEXT_START_DATE_OR_UNCHECKED_PRESENT: "Please select Start Date or unchecked present.",
    TEXT_ALREADY_ADDED: "You have already added",
    TEXT_WOULD_YOU_LIKE_TO: "Would you like to",
    TEXT_ADD_NEW_ENTRY: "add new entry",
    TEXT_UPDATE_TIMEFRAME: "update the timeframe",
    TEXT_UPDATE: "UPDATE",
    TEXT_ADD_NEW: "ADD NEW",
    TEXT_COMPANY_EXIST_SELECTED_TIMEFRAME:
      "This Company already exist within the selected timeframe.",

    // Addeducation.jsx
    TEXT_START_DATE_BEFORE_END: "Start Date should be before the End Date",
    TEXT_EDIT_EDUCATION: "Edit Education",
    TEXT_ADD_EDUCATION: "Add Education",
    TEXT_SCHOOL: "School (Required)",
    TEXT_FIELD_OF_STUDY: "Field of study",
    // Addproducts.jsx
    TEXT_SELECT_PRODUCTS: "Select Products",
    TEXT_PRODUCTS_ARRAY_TOOLS: "Tools",
    TEXT_PRODUCTS_ARRAY_MATERIALS: "Material",
    TEXT_SHOW_ALL: "Show All",
    TEXT_SHOW_SELECTED: "Show Selected",
    BUTTON_SUBMIT: "Submit",
    BUTTON_CLOSE: "Close",
    TEXT_SEARCH_PRODUCTS: "Search Products",
    // Editabout.jsx
    TEXT_ENTER_VALID_EMAIL: "Enter Valid Email Id",
    TEXT_VALID_COUNTRY_CODE: "Please enter a valid Country Code.",
    TEXT_VALID_PHONE_CODE: "Please enter a valid Phone Number.",
    TEXT_EDIT_ABOUT: "Edit About",
    TEXT_ABOUT_INSTRUCTION:
      "Selected emails and phone numbers will be visible to your Builder Network.",
    TEXT_EMAILS: " Emails",
    TEXT_NEEDS_TO_BE_VERIFIED: "needs to be verified",
    BUTTON_VERIFY: "Verify",
    TEXT_PRIMARY: "Primary",
    TEXT_EMAIL_TYPE: "Email Type",
    TEXT_PERSONAL: "Personal",
    TEXT_WORK: "Work",
    TEXT_OTHER: "Other",
    TEXT_EMAIL: "Email",
    BUTTON_ADD_EMAIL: "Add Email",
    TEXT_PHONE_NUMBERS: "Phone Numbers",
    TEXT_PHONE_TYPE: "Phone Type",
    TEXT_HOME: "Home",
    TEXT_MOBILE: "Mobile",
    TEXT_CODE: "Code",
    TEXT_PHONE_NUMBER_PLACEHOLDER: "Phone Number",
    BUTTON_ADD_PHONE: "Add Phone",
    TEXT_ADDRESS: "Address",
    TEXT_ADD_SUBHEADING:
      "Take advantage of the Ride Share opportunities in the BuildID community. Your address is never displayed and only used to match you with people in your area.",
    TEXT_SELECT_COUNTRY: "Select Country",
    TEXT_ADD_PLACEHOLDER: "Apartment, suite, etc.",
    TEXT_CITY_PLACEHOLDER: "City",
    TEXT_PROVIENCE: "Province",
    TEXT_POSTAL_CODE: "Postal Code",
    TEXT_CLEAR_ADDRESS: "Clear Address",
    TEXT_COUNTRY_CODE: "Contry Code",
    // EditProfile.jsx
    TEXT_EDIT_PROFILE: "Edit Profile",
    TEXT_PROFILE_PICTURE: "Profile Picture",
    BUTTON_CHANGE_PROFILE_PIC: "Change Profile Picture",
    TEXT_NAME: "Name",
    TEXT_TRADE: "Trade",
    TEXT_SIMILAR_TRADE_DESC: "Connect with similar BuildID users by adding your Trade(s)",
    TEXT_FIRST_NAME: "First Name",
    TEXT_LAST_NAME: "Last Name",
    TEXT_FIRST_NAME_LARGE: "First name too large.",
    TEXT_LAST_NAME_LARGE: "Last name too large.",
    // EditTrade.jsx
    TEXT_DELETE_TRADE_INSTRUCTION:
      "This trade cannot be deleted because it is used with one or more of the sites in your timeline.",
    TEXT_EDIT_TRADES: "Edit Trades",
    TEXT_SEARCH_FOR_TRADE: "Search for trade",
    TEXT_MAIN: "Main",
    TEXT_VISIBLE_TRADE_LABEL: "Your Trades are visible to others",
    // Education.jsx
    TEXT_MY_EDUCATION: "My Education",
    TEXT_EDUCATION_INFO: "Education",
    BUTTON_ADD_MY_EDUCATION: "Add My Education",
    BUTTON_BACK: "Back",
    BUTTON_EDIT: "Edit",
    TEXT_EDUCATION_DESCRIPTION:
      "Strengthen your resume and earn BuilderBucks by adding any certifications, degrees, or training experiences you have accomplished.",
    // Experience.jsx
    TEXT_MY_EXPERIENCE_HEADING: "My Experience",
    TEXT_EXPERIENSE_INFO: "Experience",
    BUTTON_ADD_MY_EXPERIENCE: "Add My Experience",
    TEXT_ADD_COMPANY: "Add Company",
    BUTTON_VIEW_BY_COMPANY: "View By Company",
    BUTTON_VIEW_BY_SITES: "View By Sites",
    TEXT_EXPERIENCE_DESCRIPTION:
      "Strengthen your resume and earn BuilderBucks by adding the Companies and Projects you worked on.",
    TEXT_ADD_PROJECT: "Add Project",
    TEXT_EDIT_COMPANY: "Edit Company",
    TEXT_EDIT_PROJECT: "Edit Project",
    TEXT_NO_COMPANY: "No Company",
    // Products.jsx
    TEXT_PRODUCTS: "Products",
    TEXT_ABOUT_INFO: "About",
    TEXT_ADD_MY_PRODUCTS: "Add My Products",
    TEXT_DESC_PRODUCT_PROFILE:
      "List any Materials or Tools you have used to complete your Profile and earn BuilderBucks",
    // VerifyEMailModal.jsx
    TEXT_ALERT_VERIFY_EMAIL: "An email has been sent to your inbox",
    BUTTON_OK: "Ok",
    // VerifyEmailModal.jsx
    TEXT_ALERT_RESET_CODE_TITLE: "Reset Code Error",
    TEXT_ALERT_RESET_CODE_DESC: "Please enter a valid reset code.",
    TEXT_ALERT_VERIFICATION_CODE_TITLE: "Verification Code Error",
    TEXT_ALERT_VERIFICATION_CODE_DESC: "The verification code entered is incorrect.",
    TEXT_ALERT_PHONE_TITLE: "Phone Number Verified!",
    TEXT_ALERT_PHONE_DESC: " has been verified!",
    TEXT_ALERT_RESEND_VERIFICATION_TITLE: "Verification code resend",
    TEXT_ALERT_RESEND_VERIFICATION_DESC: "The verification code has been resent to",
    TEXT_VERIFY_PHONE: "Verify Phone",
    TEXT_INSTRUCTION_1: "Enter the 6 digit code sent to",
    TEXT_INSTRUCTION_2: "to verify that this Phone belongs to you.",
    TEXT_DIDNT_RECEIVE_CODE: "Didn't receive a code?",
    // Viewexperience.jsx
    TEXT_PROMPT_DELETE_EXPERIENCE: "Delete Experience",
    TEXT_PROMPT_DESC: "Are you sure you want to delete this Experience from your Profile?",
    BUTTON_MODAL_DELETE_YES: "Yes",
    BUTTON_MODAL_DELETE_NO: "No",
    TEXT_VIEW_EXPERIENCE: "View Experience",
    TEXT_SITE_PROJECT: "Site/Project",
    TEXT_COMPANY: "Company",
    TEXT_START_DATE: "Start Date",
    TEXT_END_DATE: "End Date",
    TEXT_LABEL_DESCRIPTION: "Description",
    TEXT_EDIT_TRADES_ON_PROFILE: "Edit Trades on Profile",
    TEXT_REQUIRED: "*Required",
    TEXT_MONTH_YEAR: "Month - Year",
    TEXT_PRODUCTS_IN_PROFILE: "Products",
    TEXT_REFER_SOMEONE_TO_BUILDID: "Refer someone to BuildID"
  },

  Home: {
    BUTTON_ALL: "All",
    BUTTON_PROJECTS: "Projects",
    BUTTON_TRADES: "Trades",
    BUTTON_PRODUCTS: "Products",
    BUTTON_ADD_POST: "Add Post",
    MORE_MENU_HIDE_POST: "Hide Post",
    MORE_MENU_REPORT_POST: "Report Post",
    TEXT_REPORT: "Report",
    MODAL_ADD_POST_PLACEHOLDER: "What do you want to talk about?", //
    MORE_MENU_ON_NOTIFICATIONS: "Turn on notifications for this Post",
    MORE_MENU_OFF_NOTIFICATIONS: "Turn off notifications for this Post",
    TEXT_WRITE_A_POST: "Write a Post",
    MODAL_TEXT_INFO: "Posting here will be seen by your Builder Network",
    TEXT_WHAT_DO_TALK_ABOUT: "What do you want to talk about?",
    BUTTON_CANCEL: "Cancel",
    BUTTON_POST: "Post",
    MODAL_BUTTON_POSTING: "Posting...",
    MODAL_TEXT_COMMENT_PLACEHOLDER: "Write a comment",
    ALERT_TEXT_IMPRESSIONS: "Impressions",
    ALERT_IMPRESSIONS_FIRST_PART: "This post was seen on BuildId",
    ALERT_IMPRESSIONS_LAST_PART: "times.",
    ALERT_VIEWS_HEADING: "Views",
    ALERT_VIEWS_SUB_HEADING: "BuildID users opened this post",
    BUTTON_OK: "OK",
    TEXT_BUILDID_INFO: "BuildID Info",
    TEXT_OFFICIAL_ANOUNCEMENT: "Official announcements from the My BuilderID team.",
    TOP_BAR_MENU_HELP_CENTER: "Help Center",
    TEXT_MORE_MODAL_TUTORIAL: "Tutorial",
    TEXT_PLACEHOLDER_NO_POSTS: "No Posts...",
    TEXT_ALL_POST_SEEN: "You have seen it all!",
    BUTTON_SEE_MORE: "see more",
    BUTTON_SEE_LESS: "see less",
    PROGRESS_HEADING:
      "Add your contact information to your Profile so others can get in touch with you.",
    PROGRESS_SUBHEADING_1: "Add your Current trade",
    PROGRESS_SUBHEADING_2: "Follow a Single project that interests you",
    PROGRESS_SUBHEADING_3: "Add to your Education",
    PROGRESS_SUBHEADING_4: "Add to your Experiences",
    PROGRESS_SUBHEADING_5: "Spend a Builderbuck (under rewards)",
    PROGRESS_BUTTON_DISMISS: "Dismiss",
    TEXT_GO_TO_PROFILE: "Go to Profile",
    PROGRESS_ALERT_TITLE: "Are you sure you want to hide the progress bar?",
    TEXT_DELETE: "Delete",
    APP_REDIRECT_PROMPT_TITLE: "Open link in App",
    APP_REDIRECT_PROMPT_DESC: "Please choose your option.",
    APP_REDIRECT_PROMPT_RED_BTN: "Web",
    APP_REDIRECT_PROMPT_BLUE_BTN: "Open App"
  },

  Sites: {
    TEXT_FOLLOWING: "Following",
    TEXT_MY_SITES: "My Sites",
    TEXT_ONLY_SHOW_ACTIVE_SITES: "Only show Active Sites",
    TEXT_SEARCH_MAP: "Search map",
    TEXT_SITE_FAB_BUTTON_ADD_SITE: "Add Site",
    TEXT_SITE_FAB_BUTTON_PIN_MY_LOCATION: "Pin my location",
    TEXT_UNNAMED: "Unnamed",
    TEXT_SITES_INFO: "item(s) you added that need action from you",
    TEXT_THERE_ARE: "There are",
    BUTTON_OK: "OK",
    TEXT_NO_LOCATION: "No Location",
    TEXT_NO_LOCATION_SITE_ALERT:
      "This Site will not be visible to others until a location is added.",
    TEXT_NO_LOCATION_SITE_INFO:
      "The following sites are missing a location. If you know where they are, add it here",
    BUTTON_ADD_DESCRIPTION: "ADD DESCRIPTION",
    BUTTON_ADD_SITE_LOCATION: "ADD SITE LOCATION",
    BUTTON_FOLLOW_ALL: "FOLLOW ALL",
    BUTTON_FOLLOWING_ALL: "FOLLOWING ALL",
    TEXT_ACTIVE: "Active",
    TEXT_ADD_PROJECT: "ADD PROJECT",
    TEXT_NO: "NO",
    TEXT_NO_LOCATION_PROJECT_PLACEHOLDER: "No Projects have been added to this location",
    TEXT_OTHER_DESCRIPTION: "Other Descriptions",
    TEXT_PROJECTS: "Project(s)",
    TEXT_SITE_CARD_MORE_MENU_ADD_DESCRIPTION: "Add Description",
    TEXT_SITE_CARD_MORE_MENU_ADD_LOCATION: "Add Location",
    TEXT_SITE_CARD_MORE_MENU_DELETE_SITE: "Delete Site",
    TEXT_SITE_CARD_PROJECT_MORE_MENU_ADD_TO_PROFILE: "Add to profile",
    TEXT_UNFOLLOW_PROJECT_ALERT: "Do you want to unfollow all projects?",
    TEXT_YES: "YES"
  },

  RewardStore: {
    PAGE_HEADER: "Rewards",
    TEXT_REWARD_STORE_HEADER: "Store",
    TEXT_ACCOUNT_ACTIVITY_HEADER: "Account Activity",
    TEXT_EARN_BUILDERBUCKS_HEADER: "Earn Builder Bucks",
    BUTTON_STORE: "Store",
    BUTTON_EARN_BUILDER_BUCKS: "Earn Builder Bucks",
    BUTTON_REWARDS_ACTIVITY_LOG: "Rewards Activity Log",
    TEXT_YOUR_BALANCE: "Your Balance:",
    TEXT_BUILDER_BUCKS: "BuilderBucks",
    TEXT_HEADER_SUBTITLE: "* BuildID uses ads to help fund the Rewards Store",
    TEXT_NO_REWARDS: "Currently there are no rewards in your location",
    TEXT_PER_ENTRY: "per entry",
    TEXT_ENTRIES: "entries",
    TEXT_QUANTITY: "Quantity",
    BUTTON_NO_ENOUGH_ENTRIES: "No Enough entries",
    BUTTON_ENTER_TO_WIN: "Enter to win",
    TEXT_NOT_ENOUGH: "Not enough",
    TEXT_ENTERED: "Entered",
    TEXT_TIMES: "times",
    TEXT_SUCCESS_DIALOG_DESC: "You have successfully registered for the draw!",
    TEXT_CLOSE_DIALOG_DESCRIPTION: "Sorry! You don't have enough BuilderBucks yet.",
    TEXT_HELLO: "Hello",
    TEXT_EARN_REWARDS_MESSAGE: "You have questions you can answer to earn more BuilderBucks!",
    BUTTON_EARN_REWARDS: "Earn Rewards",
    TEXT_HOW_TO_EARN_BUILDERBUCKS: "How to earn BuilderBucks",
    TEXT_BUILD_ID_REWARDS:
      "BuildID wants to reward you for what you know about the sites you work on!",
    TEXT_CONSTRUCTION_COMMUNITY: "Construction Community",
    TEXT_REFER_SOMEONE_TO_BUILDID_1: "For every new user that you refer to BuildID.",
    TEXT_REFER_SOMEONE_TO_BUILDID_2: "Ways you can invite people:",
    TEXT_ADDING_CONTACTS: "Adding Contacts",
    TEXT_INVITE_OTHERS_TO_BE_A_PART_OF_THIS:
      "Invite others to be a part of this great construction community and earn BuilderBucks for each new contact you add!",
    TEXT_SEND_INVITE: "Send Invite",
    TEXT_YOUR_SITE: "Your Sites",
    TEXT_FOR_EVERY_NEW_SITE: "For every new site you add to your timeline.",
    TEXT_GO_TO_SITES: "Go To Sites",
    TEXT_EARN_MORE_BUILDERBUCKS:
      "Ways you can earn more BuilderBucks from the sites added to your timeline:",
    TEXT_SITE_IMAGES: "Site Images",
    TEXT_FOR_ADDING_PICTURES: "For adding pictures you take of your sites. We want to see them!",
    TEXT_TAP_THE: "Tap the",
    TEXT_ADD_PICTURE: "Add Picture",
    TEXT_BUTTON_FOR_EACH_SITE: "button from each site in your timeline.",
    TEXT_COMPANY_ROLES: "Company Roles",
    TEXT_COMAPNY_ROLE_SUBTEXT_1:
      "For adding the role your company played at each site you worked at.",
    TEXT_COMAPNY_ROLE_SUBTEXT_2: "Under the Companies section of each site, tap.",
    TEXT_NEXT_TO_YOUR_COMPANY: "next to your company name.",
    TEXT_OTHER_COMPANIES: "Other Companies",
    TEXT_OTHER_COMPANYS_SUBTEXT:
      "For adding other companies that worked on the sites you worked at.",
    TEXT_ADD_COMPANY: "Add Company",
    TEXT_OTHER_COMPANY_SUBTEXT2: "button under the Companies section of each site.",
    TEXT_SITE_PRODUCTS: "Site Products",
    TEXT_SITE_PRODUCTS_SUBTEXT: "For adding any products you worked with while on the site.",
    TEXT_ADD_PRODUCT: "Add Product",
    TEXT_SITE_PRODUCT_SUBTEXT_2: "button under the Products section of each site.",
    TEXT_MANUFACTURERS_PRODUCTS: "Manufacturers and Products",
    TEXT_MANUFACTURERS_PRODUCTS_SUBTEXT:
      "For every new manufacturer and/or product you add that gets approved.",
    TEXT_MANUFACTURERS_PRODUCTS_SUBTEXT_2: "You can earn even more by adding things to products!",
    BUTTON_GO_TO_MANUFACTURER_PROFILES: "Go To Manufacturer Profiles",
    BUTTON_GO_TO_PRODUCT_PROFILES: "Go To Product Profiles",
    TEXT_RATE_THIS_PRODUCT: "Rate This Product",
    TEXT_RATE_SUBTEXT: "For adding what you thought about each product you have worked with.",
    TEXT_PRODUCT_IMAGES_GALLERY: "Product Image Gallery",
    TEXT_PRODUCT_IMAGES_GALLERY_SUBTEXT: "For adding pictures you have taken of the product.",
    TEXT_BARCODE_IMAGE_GALLERY: "Barcode Image Gallery",
    TEXT_BARCODE_IMAGE_GALLERY_SUBTEXT: "For scanning in the barcode for a product.",
    TEXT_SHAREING_YOUR_KNOWLEDGE: "Sharing Your Knowledge",
    TEXT_FEEDBACK: "Your feedback is important to us!",
    TEXT_ANS_QUESTIONS: "Answer Questions",
    TEXT_ANS_QUESTIONS_SUBHEADING: "BuilderBucks vary per question",
    TEXT_ANS_QUESTIONS_SUBTEXT:
      "Show off all your knowledge and earn free stuff by doing so! There will be new questions to answer each day.",
    TEXT_REPORT_INCORRECT_INFORMATION: "Report Incorrect Information",
    TEXT_REPORT_INCORRECT_INFORMATION_SUBTEXT:
      "For any information inside BuildID that doesn't seem right to you. We want to get these fixed!",
    TEXT_TAP: "Tap",
    TEXT_REPORT_INCORRECT_INFORMATION_SUBTEXT_2: "next to the data you disagree with.",
    TEXT_FOOTER_NOTE:
      "BuilderBucks awarded for information that is later deleted and/or found to be incorrect may be revoked",
    TEXT_ALL_ACTIVITY: "ALL",
    TEXT_EARNINGS_ACTIVITY: "EARNINGS",
    TEXT_SPENDINGS_ACTIVITY: "SPENDINGS",
    TEXT_DEDUCTIONS_ACTIVITY: "DEDUCTIONS",
    TEXT_REWARD_LOCATION: "Reward Location",
    TEXT_LOCATION_VERIFY_HEADER: "Rewards Requires User location",
    TEXT_LOCATION_VERIFY_SUB_HEADER1: "To add your location, go to About tab in Profile.",
    TEXT_LOCATION_VERIFY_SUB_HEADER2: "(Address needs to set before coming to rewards).",
    TEXT_BACK_TO_DASHBOARD: "Back to Dashboard",
    TEXT_GO_TO_PROFILE: "Go to Profile",
    TEXT_PLACEHOLDER_NO_DATA: "No Data Available",
    TEXT_ASK_ME_LATER: "Ask me later",
    TEXT_DONT_ASK_BTN: "Don't ask again",
    TEXT_SUBMIT_BTN: "Submit",
    TEXT_QUESTION_OF_THE_DAY: "Question of the day",
    TEXT_MONTH_YEAR: "Month - Year",
    TEXT_SEARCH_FOR: "Search for a",
    TEXT_ANSWER: "Answer",
    TEXT_VALID_ENTRIES: "Please enter valid number of entries!",
    TEXT_NO_MORE_QUESTIONS: "No more questions available at this time! Please try again later.",
    TEXT_ADD: "Add",
    TEXT_ADD_ANSWER: "Add Answer",
    TEXT_START_DATE: "Start Date",
    TEXT_END_DATE: "End Date",
    TEXT_PRESENT: "Present",
    TEXT_SELECT: "Select",
    TEXT_SELECT_UP_TO: "Select up to",
    TEXT_SELECT_ALL_THAT_APPLY: "Select all that apply",
    TEXT_ADD_OPTIONS: "ADD OPTION",
    TEXT_SEARCH_FOR_ADDRESS: "Search for the address",
    TEXT_SUBMITTED_ANSWER: "Your Answer was Submitted",
    TEXT_EARNED_BY_ANS: "Earned by answering this question",
    BUTTON_LEARN_MORE: "Learn more",
    TEXT_START_DATE_END_DATE_TITLE:
      "Start Date should be before the End Date, or click I currently work here if you are still working on this site.",
    TEXT_YOU_CAN_SELECT_UPTO: "You can only select upto",
    TEXT_RESPONSES: "Responses",
    TEXT_INDICATE_COMPANY_ROLE: "Please Indicate Company Role",
    TEXT_NOT_ENOUGH_BUILDERBUCKS: "Not enough BuilderBucks",
    TEXT_TODAY: "Today",
    TEXT_YESTERDAY: "Yesterday",
    TEXT_EARN: "Earn",
    TEXT_HISTORY: "History",
    BUTTON_REDEEM: "Redeem",

    TEXT_FIRST_LIST_ITEM_SUBHEADING:
      "Show off all your knowledge and earn free stuff by doing so! There will be new questions to answer every day.",
    TEXT_ADD_NEW_CONSTRUCTION_SITE: "Add New Construction Sites",
    TEXT_SECOND_LIST_ITEM_SUBHEADING:
      "To earn more BuilderBucks, also add pictures, companies that worked at the site, and products used.",
    TEXT_ADD_NEW_COMPANIES: "Add new companies",
    TEXT_THIRD_LIST_ITEM_SUBHEADING:
      "Earn BuilderBucks by adding new construction companies or manufacturers. Enter their contact information, associated trade, and any projects they were involved in.",
    TEXT_SUBMIT_PRODUCTS: "Submit products",
    TEXT_FOUR_LIST_ITEM_SUBHEADING:
      "Earn BuilderBucks for each new Product you add. Share photos, barcodes, and review products.",
    TEXT_CONNECT_OTHER_BUILDERS: "Connect with other Builders",
    TEXT_FIVE_LIST_ITEM_SUBHEADING:
      "Invite others to be a part of this great construction community and earn BuilderBucks for each new Builder you add!",
    TEXT_SIX_LIST_ITEM_SUBHEADING:
      "See something that doesn't seem right to you? Tap the '...' icon next to the data you disagree with.",
    TEXT_VARIES: "Varies"
    // BUTTON_CANCEL: "Cancel",
    // BUTTON_REPORT: "Report",
    // BUTTON_REWARDS_STORE: "Rewards Store",
    // TEXT_ADD_NEW_THINGS: "We are always adding new things, so check back often!",
    // TEXT_REDEEM_BUILDERBUCKS: "Redeem your BuilderBucks for cool stuff in our store!",
    // TEXT_MODAL_CANCEL: "Cancel",
    // TEXT_MODAL_REPORT: "Report",
    // TEXT_VIEW_DETAILS: "View Details",
    // TEXT_YOU_HAVE: "You have",
    // TEXT_APP_HEADER: "Store",
    // TEXT_BACK_TO_TOOL: "Back to My Tools",
    // TEXT_DIALOG_SECOND_BTN: "OK",
    // TEXT_HEADER_BALANSE: "Balance:",
    // TEXT_HEADER_BUILDER_BUCKS: "BuilderBucks",
    // TEXT_BUILDERBUCKS_COUNT: "BuilderBucks",
    // TEXT_LOCATION_VERIFY_HEADER2: "To add your location, go to About tab in Profile. (Address needs to set before coming to rewards).",
  },

  Companies: {
    BUTTON_ADD_ANOTHER_ADDRESS: "ADD ANOTHER ADDRESS",
    TEXT_ADD_COMPANY: "Add Company or Manufacturer",
    BUTTON_ADD_PROJECT: "Add Project",
    BUTTON_REPORT: "Report",
    BUTTON_SEND_IN_CHAT: "Send in Chat",
    BUTTON_SHARE: "Share",
    TEXT_ABOUT_INFO: "About",
    TEXT_ADD_PRODUCT: "Add Product",
    TEXT_COMPANY: "Company",
    TEXT_COMPANY_PROFILES: "Company and Manufacturer Listing",
    TEXT_COMPANY_PROJECTS_DESC: "The Projects that this Company has worked at",
    TEXT_FOR_COMPANY_VIEW: "The Products that this Company has used",
    TEXT_PRODUCTS: "Products",
    TEXT_PROJECTS: "PROJECTS",
    TEXT_RESULTS: "Results",
    NO_RESULT: "No results found",
    TEXT_SEARCH_COMPANY: "Search Companies",
    TEXT_SEARCH_COMPANY_PROJECTS: "Search this Company's Projects",
    TEXT_SEARCH_COMPANY_PRODUCTS: "Search this Company's Produts",
    NO_INFORMATION_ABOUT: "No Information about this company.",
    TEXT_NO_DATA_INFO_SUBTEXT: "Know any information? Add it here for builderbucks",
    TEXT_TRADE_COMPONY: "Add Trade",
    TEXT_ADD_WEBSITE: "Add a Website",
    TEXT_ADD_PHONE_NUMBER: "Add Phone Number",
    TEXT_ADD_ADDRESS_TITLE: "Add Address",
    BUTTON_ADD_ADDRESS_AND_CONTACT: "Add Address & Contact",
    BUTTON_ADD_ANOTHER_ADDRESS_AND_CONTACT: "Add Another Address & Contact",
    TEXT_ADD_CONTACT_INFO: "Add Contact Info",
    TEXT_NO_INFO_COMPANY: "No information for this company.",
    TEXT_NO_RESULTS_FOUND: "No results found. Try again later or adjust your filters.",
    NO_ROLE: "No Role",
    TEXT_DELETE_COMPANY_TARDES: "Delete Company Trades",
    TEXT_DELETE_COMPANY_TARDES_DEC: "Are you sure you want to delete this Trade?",
    TEXT_NO_PROJECT_FOUND: "No Project Found",
    TEXT_ADD_PRODUCT_TO_COMPANY: "Add Product to Company",

    TEXT_SITES: "Sites",
    TEXT_JOB_POSTINGS: "Job Postings",
    TEXT_ADD_SITE: "Add Site",
    TEXT_SEARCH_COMPANY_SITES: "Search this Company's Sites"
  },

  Manufacturers: {
    TEXT_ADD_PRODUCT: "Add Product",
    TEXT_NO_INFO_MANUFACTURER: "No Information about this manufacture.",
    TEXT_ADD_PROJECT: "Add Project",
    TEXT_ADD_MANUFACTURER: "Add Manufacturer",
    BUTTON_ADD_ADDRESS: "ADD ADDRESS",
    BUTTON_ADD_PHONE: "ADD PHONE",
    BUTTON_ADD_WEBSITE: "ADD WEBSITE",
    BUTTON_SEND_IN_CHAT: "Send in Chat",
    BUTTON_REPORT: "Report",
    BUTTON_SHARE: "Share",
    TEXT_ABOUT_INFO: "About",
    TEXT_ADD_EMAIL: "Add Email",
    TEXT_MANUFACTURER: "Manufacturer",
    TEXT_MANUFACTURER_PROFILES: "Manufacturer Profiles",
    TEXT_MANUFACTURER_PROJECTS_DESC:
      "The Projects that the Manufacturers products have been used at",
    TEXT_NO_DATA_INFO: "No information about this manufacturer.",
    TEXT_NO_DATA_INFO_SUBTEXT: "Know any information? Add it here for builderbucks",
    TEXT_PROJECTS: "PROJECTS",
    TEXT_PRODUCTS: "Products",
    TEXT_RESULTS: "Results",
    TEXT_SEARCH_MANUFACTURERS: "Search Manufacturers",
    NO_RESULT: "No results found",
    TEXT_DELETE_MANUFACTURERS_TARDES: "Delete Manufacture Trades",
    TEXT_DELETE_COMPANY_TARDES_DEC: "Are you sure you want to delete this Trade?",
    TEXT_TRADE_COMPONY: "Add Trade",
    TEXT_ADD_WEBSITE: "Add a Website",
    TEXT_ADD_PHONE_NUMBER: "Add Phone Number",
    TEXT_ADD_ADDRESS_TITLE: "Add Address",
    BUTTON_ADD_ADDRESS_AND_CONTACT: "Add Address & Contact",
    BUTTON_ADD_ANOTHER_ADDRESS_AND_CONTACT: "Add Another Address & Contact",
    TEXT_ADD_CONTACT_INFO: "Add Contact Info",
    TEXT_PRODUCT_MANUFACTURER: "The Products that this Manufacturer has manufactured",
    BUTTON_ADD_ANOTHER_ADDRESS: "ADD ANOTHER ADDRESS",
    TEXT_NO_RESULTS_FOUND: "No results found. Try again later or adjust your filters.",
    TEXT_PROJECT_MANU: "The Projects that this Manufacturers products have been used at",
    TEXT_SEARCH: "Search",
    TEXT_PROJECTS: "Projects",
    TEXT_PRODUCTS: "Products",
    TEXT_NO_PROJECT_FOUND: "No Project Found",
    TEXT_ADD_PRODUCT_TO_MANUFACTURER: "Add Product to Manufacturer",
    // Filters
    TEXT_SEARCH_FILTER: "Filter",
    TEXT_NEW_FILTERS: "Filters",
    TEXT_FILTER_PRODUCT_TYPE: "Product Type",
    TEXT_VERIFIED: "Verified",
    TEXT_GROUP: "Group",
    BUTTON_CLEAR_ALL: "Clear all",
    BUTTON_APPLY: "Apply"
  },

  Products: {
    TEXT_PRODUCTS: "Products",
    TEXT_ALL_PRODUCTS: "All Products",
    TEXT_MY_PRODUCTS: "My Products",
    TEXT_ALL: "All",
    TEXT_PRODUCTS_ARRAY_TOOLS: "Tools",
    TEXT_PRODUCTS_ARRAY_MATERIALS: "Material",
    TEXT_ROUNDED_TABS_WORK_WITH: "Worked With",
    TEXT_FOLLOWING: "Following",
    TEXT_FOLLOW: "Follow",
    TEXT_RESULTS: "Results",
    TEXT_SEARCH_PRODUCTS: "Search Products",
    BUTTON_ADD_PRODUCT: "Add Product",
    BUTTON_REPORT: "Report",
    BUTTON_REMOVE_FROM_MY_PRODUCTS: "Remove from My Products",
    BUTTON_ADD_PRODUCT_PICTURE: "Add Product Picture",
    BUTTON_SEND_IN_CHAT: "Send in Chat",
    BUTTON_SHARE: "Share",
    BUTTON_I_WORKED_WITH_THIS: "I worked with this",
    BUTTON_ABOUT: "ABOUT",
    BUTTON_POSTS: "POSTS",
    BUTTON_PHOTOS: "PHOTOS",
    BUTTON_REVIEWS: "REVIEWS",
    BUTTON_PROJECTS: "PROJECTS",
    BUTTON_COMPANIES: "COMPANIES",
    TEXT_DELETE_MODAL_DESC1: "Are you sure you want to unfollow this Product Page",
    TEXT_DELETE_MODAL_DESC2: "Remove this Product from Products you have worked with?",
    BUTTON_MODAL_DELETE_REMOVE: "Remove",
    BUTTON_MODAL_DELETE_YES: "Yes",
    TEXT_NO_INFO_PRODUCT: "No information for this product.",
    TEXT_NO_INFO_PRODUCT_SUBTEXT: "Know any information? Add it here for builderbucks",
    TEXT_TRADE_COMPONY: "Add Trade",
    TEXT_ADD_MANUFACTURER: "Add Manufacturer",
    TEXT_ADD_WEBSITE: "Add a Website",
    TEXT_ADD_DESCRIPTION: "Add Description",
    TEXT_DELETE_PRODUCT_TARDES: "Delete Product Trades",
    TEXT_DELETE_COMPANY_TARDES_DEC: "Are you sure you want to delete this Trade?",
    TEXT_NO_PHOTOS: "No photos avilable",
    TEXT_WRITE_A_REVIEW: "Write a Review",
    TEXT_NO_INFO_REVIEW: "Share your thoughts with other BuildId Users.",
    TEXT_WHAT_DO_TALK_ABOUT: "What do you want to talk about?",
    TEXT_POST_MESSAGE_TITLE: "Posting here will be seen by everybody following the product",
    NO_RESULT: "No results found",
    TEXT_NO_RESULTS_FOUND: "No results found. Try again later or adjust your filters.",
    TEXT_PRODUCT_PROJECTS_DESC: "Projects that this product has been used at",
    TEXT_SEARCH_PRODUCT_PROJECTS: "Search this Product's Projects",
    BUTTON_ADD_PROJECT: "Add Project",
    TEXT_ADD_NEW_COMPANY: "Add Company",
    TEXT_PRODUCT_COMPANIES_DESC: "Companies that have used this product",
    TEXT_SEARCH_PRODUCT_COMPANIES: "Search this Product's Companies",
    TEXT_ADD_COMPANY_TO_PRODUCT: "Add Company to Product",
    TEXT_COMMENTS: "Comments",
    TEXT_NO_PROJECT_FOUND: "No Project Found",
    TEXT_ADD_PRODUCT: "Add Product",
    TEXT_NO_PRODUCT_VISIBLE:
      "This product will not be visible to others until a manufacturer is added.",

    TEXT_NO_INFORMATION_ABOUT_PRODUCT: "No Information about this Product",
    TEXT_SEARCH_THIS_PRODUCT_SITES: "Search this Product's Sites",
    TEXT_ARE_YOU_SURE_DELETE_IMAGE: "Are you sure you want to delete this image?",

    //PRODUCT DOCUMENTS SECTION
    TEXT_TECHNICAL_INFO: "Technical Info",
    TEXT_UPLOAD_FILE: "Upload File",
    TEXT_CHOOSE_FILE: "Choose File",
    TEXT_ADD_DESC_PLACEHOLDER: "Add Description for the file",
    TEXT_UPLOADING: "Uploading...",
    TEXT_DOCEMENTS: "Documents",
    TEXT_RECENTS: "Recents",
    TEXT_TECHNICAL_DOCUMENTS: "Technical Documents",
    TEXT_ALL_DOCUMENTS: "All Documents",
    TEXT_LOADING_DOCEMENTS: "Loading Documents...",
    TEXT_NO_DOCUMENTS: "No Documents found",
    TEXT_UPLOAD_DOCUMENTS_PLACEHOLDER: "Upload your first document to get started",
    TEXT_LOADING_MORE_DOCEMENTS: "Loading more documents...",
    TEXT_FILE_SAVED_SUCCESS: "File uploaded successfully!",
    TEXT_FAILED_TO_SAVE_FILE: "Failed to upload file. Please try again.",
    TEXT_PLEASE_SELECT_FILE: "Please select a file first.",
    TEXT_ENTER_DESCRIPTION: "Please enter a file description.",

    TEXT_FILE_DETAILS: "File Details",
    TEXT_FILE_INFORMATION: "File Information",
    TEXT_FILE_NAME: "File Name",
    TEXT_FILE_TYPE: "File Type",
    TEXT_FILE_DESCRIPTION: "Description",
    BUTTON_DOWNLOAD: "Download File",
    BUTTON_CLOSE: "Close",
    TEXT_RELETED_TO: "Related To",
    TEXT_UPLOADED_ON: "Uploaded On",
    TEXT_CLICK_DOWNLOAD: "Click download to view this file"

    // TEXT_COMPANY_INFO_SUBTEXT: "Add it here for builderbucks",
    // TEXT_FOR_COMPANY_VIEW: "The Products that this Company has used",
    // TEXT_FOR_MANUFACTURER_VIEW: "The Products that this Manufacturer has manufactured",
    // TEXT_FOR_TRADE_VIEW: "Products that are useful to this trade",
    // TEXT_MANUFACTIRER_INFO: "Has this company created any products? Fill in information for builderbucks!",
    // TEXT_NO_INFO_COMPANY: "No information for this company.",
    // TEXT_NO_INFO_COMPANY_MANUFACTURER_TRADE_SUBTEXT:
    //   "Know any information? Add it here for builderbucks",
    // TEXT_NO_INFO_MANUFACTURER: "No information about this manufacturer.",
    // TEXT_NO_INFO_TRADE: "No information about this Trade.",
    // TEXT_SEARCH_THIS: "Search this",
    // TEXT_TRADE_DETAILS_INFO: "Know any Products that this trade would use? ",
    // TEXT_TRADE_DETAILS_INFO_SUBTEXT: "Let us know for builderbucks!",
    // BUTTON_ADD: "ADD",
    // BUTTON_DISCARD: "Discard",
    // BUTTON_NO_THANKS: "No Thanks",
    // BUTTON_VIEW: "VIEW",
    // TEXT_ADD_PRODUCT: "Add Product",
    // TEXT_ADD_PRODUCT_TO_COMPANY: "Add Product to Company",
    // TEXT_ADD_PRODUCT_TO_MANUFACTURER: "Add Product to Manufacturer",
    // TEXT_ADD_PRODUCT_TO_PROJECT: "Add Product to Project",
    // TEXT_ARE_YOU_SURE: "Are you sure you want to discard the changes you made?",
    // TEXT_DISCARD_CHANGES: "Discard Changes",
    // TEXT_EXISTING_PRODUCTS: "Existing Products",
    // TEXT_NO_MANUFACTURER: "(no Manufacturer)",
    // TEXT_NO_PRODUCT_NAME: "(no Product name)"
  },

  Trades: {
    BUTTON_REPORT: "Report",
    TEXT_ADD_COMPANY_TO_TRADE: "Add Company to Trade",
    TEXT_WHAT_DO_TALK_ABOUT: "What do you want to talk about?",
    TEXT_TRADE_POST: "Trade Post",
    TEXT_SHARE_YOUR_THOUGHTS: "Share your thoughts with other BuildId Users",
    TEXT_POSTING_HERE_WILL_BE_SEEN:
      "Posting here will be seen by everybody following the Trade Network",
    BUTTON_ADD_PRODUCT: "Add Product",
    TEXT_NO_RESULTS_FOUND: "No results found. Try again later or adjust your filters.",
    TEXT_SEARCH_THIS_TRADE: "Search this Trade's Products",
    TEXT_FOR_TRADE_VIEW: "Products that are useful to this trade",
    TEXT_ADD_ANOTHER_TRADE_NAME: "Add another Trade name",
    TEXT_TRADE_COMPANIES_DESC: "Companies that have used this trade",
    TEXT_RELATED_TRADES: "Related Trades",
    TEXT_ALSO_KNOWN_AS: "Also known as",
    TEXT_REPORT: "Report",
    TEXT_ARE_YOU_SURE_TO_UNFOLLOW_TRADE_PAGE: "Are you sure you want to unfollow this Trade Page",
    TEXT_REMOVE_THIS_TRADE: "Remove this Trade from your Profile",
    BUTTON_YES: "YES",
    BUTTON_REMOVE: "Remove",
    BUTTON_SEND_IN_CHAT: "Send in Chat",
    TEXT_ANOTHER_TRADE_NAME: "Another Trade Name",
    TEXT_TRADE_PROFILE: "Trade Profile",
    TEXT_CHECK_THIS_OUT: "Check this out!",
    TEXT_SEARCH_THIS_TRADE_PROJECTS: "Search this Trade's Projects",
    TEXT_THIS_TRADE_CANNOT_DELETED:
      "This trade cannot be deleted because it is used with one or more of the projects in your timeline.",
    TEXT_PROJECTS: "Projects",
    TEXT_TRADE_PROJECTS_DESC: "Projects that this Trade has worked on",
    TAB_ON_MY_PROFILE: "On My Profile",
    TEXT_FOLLOWING: "Following",
    TEXT_RESULTS: "Results",
    TEXT_SEARCH_TRADES: "Search Trades",
    TEXT_TRADES: "Trades",
    TEXT_MY_TRADES: "My Trades",
    TEXT_ALL_TRADES: "All Trades",
    TEXT_KONW_ANY_INFO: "Know any information? Add it here for builderbucks",
    BUTTON_REQUEST_ONE: "Request one",
    TEXT_FIND_YOUR_TRADE: "Can't find your Trade?",
    BUTTON_ADD_TO_PROFILE: "Add to profile",
    BUTTON_FOLLOW: "Follow",
    TEXT_ABOUT_INFO: "About",
    BUTTON_SHARE: "Share",
    TEXT_ADD_COMPANY: "Add Company",
    TEXT_NO_INFO_TRADE: "No Information about this trade.",
    TEXT_PRODUCTS: "products",
    TEXT_COMPANIES: "companies",
    BUTTON_POSTS: "posts",
    BUTTON_ADD_ANOTHER_TRADE_NAME: "Add another Trade name ",
    TEXT_SEARCH_TRADE_COMPANIES: "Search this Trade's Companies",
    TEXT_NO_PROJECT_FOUND: "No Project Found",
    TEXT_TRADE_DETAILS_INFO: "Know any Products that this trade would use? ",
    TEXT_TRADE_DETAILS_INFO_SUBTEXT: "Let us know for builderbucks!",
    NO_RESULT: "No results found",
    TEXT_ADD_PRODUCT_TO_TRADE: "Add Product to Trade",
    TEXT_TRADE: "Trade",
    TEXT_ADDED_ADMIN: "Added Admin as an alternate name.",
    TEXT_THANKS_FOR_REQUESTING_A_TRADE:
      "Thanks for requesting a Trade! We will review it to be added to BuildID"
  },

  Projects: {
    TEXT_PROJECTS: "Projects",
    TEXT_PROJECT: "Project",
    TEXT_ADD_TO_PROFILE: "Add to profile",
    BUTTON_UNFOLLOW: "Unfollw",
    BUTTON_FOLLOW: "Follow",
    BUTTON_POSTS: "posts",
    BUTTON_PHOTOS: "photos",
    TEXT_COMPANIES: "companies",
    TEXT_PRODUCTS: "products",
    BUTTON_ADD_PROJECT_PICTURE: "Add Project Picture",
    BUTTON_SEND_IN_CHAT: "Send in Chat",
    BUTTON_SHARE: "Share",
    BUTTON_REPORT: "Report",
    TEXT_UNFOLLOW_PROJECT_PAGE: "Are you sure you want to unfollow this Project Page?",
    TEXT_DELETE_MODAL_DESC2: "Remove this Product from Products you have worked with?",
    TEXT_YES: "YES",
    BUTTON_REMOVE: "Remove"
  },

  ProjectProductSection: {
    TEXT_ADD_PRODUCT: "Add Product", //
    TEXT_ADD_PRODUCTTO_PROJECT: "Add Product to Project", //
    TEXT_PROJECT_NO_INFORMATION: "No information for this project.",
    TEXT_NO_DATA_INFO_SUBTEXT: "Know any information? Add it here for builderbucks", //
    TEXT_SEARCH_PROJECT_PRODUCT: "Search this Project's Products",
    TEXT_NO_RESULTS_FOUND: "No results found. Try again later or adjust your filters.", //
    BUTTON_REPORT: "Report" //
  },

  ProjectPostsSection: {
    MODAL_ADD_POST_PLACEHOLDER: "What do you want to talk about?", //
    TEXT_SHARE_YOUR_THOUGHTS: "Share your thoughts with other BuildId Users", //
    TEXT_POSTING_SEEN_BY_PROJECT: "Posting here will be seen by everybody following the Project", //
    NO_RESULT: "No results found"
  },

  ProjectPhotosSection: {
    TEXT_NO_PHOTOS: "No photos available"
  },

  ProjectPhotosModal: {
    TEXT_SELECT_VALID_IMAGE: "Please select valid image files", //
    TEXT_PHOTO_TAKEN: "Photo taken",
    TEXT_LABEL_COMMENTS: "Comments", //
    TEXT_COMMENT: "Comment",
    BUTTON_REPORT: "Report" //
  },

  ProjectCompaniesSection: {
    TEXT_ADD_COMPANY: "Add Company", //
    TEXT_PROJECT_NO_INFORMATION: "No information for this project.", //
    TEXT_NO_DATA_INFO_SUBTEXT: "Know any information? Add it here for builderbucks", //
    TEXT_SEARCH_THIS_PROJECT_COMPANIES: "Search this Project Companies",
    BUTTON_ADD_COMPANY_ROLE_ON_PROJECT: "Add company role on Project", //
    BUTTON_REPORT: "Report", //
    TEXT_NO_RESULTS_FOUND: "No results found. Try again later or adjust your filters.", //
    TEXT_ADD_COMPANY_PROJECT: "Add Company to Project",
    TEXT_ADD_ROLE_TO_A_COMPANY: "Tap the ... button to add a role to a company.", //
    BUTTON_OK: "OK",
    TEXT_NO_ROLE: "No Role", //
    TEXT_ADD_COMPANY_TO_PROJECT: "Add Company to Project"
  },

  ProjectAboutSection: {
    TEXT_ABOUT_INFO: "About", //
    TEXT_ADD_DESCRIPTION: "Add Description", //
    BUTTON_ADD_PROJECT_TYPE: "ADD PROJECT TYPE", //
    BUTTON_ADD_WEBSITE: "Add Website", //
    TEXT_LATITUDE: "Latitude",
    TEXT_LONGITUDE: "Longitude"
  },

  AddRoleToCompanyModal: {
    TEXT_ADD_COMPANY_ROLE: "Add Company Role",
    TEXT_LABEL_PROJECT: "Project", //
    TEXT_LET_KNOW_COMPANY_ROLE_PLAYED: "Let us know what role company played in this site",
    TEXT_COMPANY_NAME: "Company Name", //
    TEXT_ROLES: "Roles",
    BUTTON_CANCEL: "Cancel", //
    BUTTON_SAVE: "Save" //
  },

  AddProjectTypeModal: {
    TEXT_CHOOSE_PROJECT_TYPE: "Choose Project Type",
    BUTTON_CLOSE: "Close", //
    BUTTON_SAVE: "Save", //
    TEXT_PLACEHOLDER_NO_DATA: "No Data Available"
  },

  Montages: {
    TEXT_APP_HEADER: "Montages",
    TEXT_ADD_MONTAGE: "Add Montage",
    TEXT_EDIT_MONTAGE: "Edit Montage",
    TEXT_BACK_BUTTON: "Back",
    TEXT_NO_IMAGE_AVAILABLE: "No Image Available",
    TEXT_MODAL_DELETE_DESCRIPTION: "Are you sure you want to delete this montage?",
    TEXT_MODAL_DELETE_TITLE: "Delete Montage",
    TEXT_NO_MONTAGES: "No Videos on montage",
    BUTTON_ADD_SOUND: "ADD SOUND",
    TEXT_MONTAGE_NAME: "Montage Name",
    BUTTON_FREEFROM: "FreeFrom",
    BUTTON_RATIO: "Ratio",
    TEXT_ADD_ON_TEXT: "Add On Text",
    TEXT_DIALOG_MONTAGE_NAME: "Please enter montage name",
    TEXT_ALERT_IMAGE_SELECT: "Please, Select Image First",
    TEXT_DIALOG_ADD_PICTURES: "Please add one or more pictures to save",
    TEXT_SOUNDS: "Sounds",
    TEXT_ADD_BLANK_PAGE: "Add Blank Page",
    TEXT_PHOTOS_FROM_PROJECT: "Photos From Project",
    TEXT_ADD_PHOTOS_FROM_PROJECT: "Add Photos From Project",
    TEXT_ADD_FROM_COMPUTER: "Add From Computer",
    BUTTON_SEE_MORE: "see more",
    BUTTON_BACK: "Back",
    BUTTON_MY_PHOTOS: "My Photos",
    BUTTON_SAVED_PHOTOS: "Saved Photos",
    BUTTON_ALL: "All",
    TEXT_SNACKBAR_PAGE_ADDED: "A new page has been added",
    BUTTON_MODAL_COPY_LINK: "Copy link",
    BUTTON_MODAL_POST: "Post",
    BUTTON_MODAL_MORE: "More",
    BUTTON_MODAL_SEND_IN_CHAT: "Send in Chat",
    BUTTON_MODAL_SHARE: "Share",
    TEXT_SNACKBAR_COPY_TO_CLIPBOARD: "Montage link copied to clipboard!",
    BUTTON_SEND: "Send",
    BUTTON_SHARE: "Share",
    TEXT_SHARE: "Share",
    TEXT_MESSAGE_PLACEHOLDER: "Write something",
    TEXT_SNACKBAR_IMAGE_LIMIT: "No picture added limit of 5 picture of gallery",
    TEXT_TITLE: "Add Title Here",
    TEXT_TUTORIAL_DESCRIPTION:
      "Create video collages using photos of your work to share with all your friends and family",
    TEXT_TUTORIAL_TAP_TO_CONTINUE: "Tap anywhere to continue",
    TEXT_TUTORIAL_VIDEO: "This is the video timeline. Add photos by tapping on the add buttons",
    TEXT_TUTORIAL_ADD_PHOTO_1: "Add a photo or blank text screen. ",
    TEXT_TUTORIAL_ADD_PHOTO_2: "Photos bordered in red are from BuildID Sites.",
    TEXT_TUTORIAL_ADD_PHOTO_3: "Photos in yellow are from your phone gallery (limited to 5)",
    TEXT_TUTORIAL_MAIN_SCREEN: "This is the main screen.",
    TEXT_TUTORIAL_MAIN_SCREEN_SUB: "Preview montage here.",
    TEXT_TUTORIAL_EDITOR: " This is the editor bar,",
    TEXT_TUTORIAL_EDITOR_SUB: " select photo to delete,add text or crop.",
    TEXT_TUTORIAL_SAVE: "Save, or play montage from the beginning and Help if you need it",
    TEXT_PLACEHOLDER_NO_DATA: "No Data Available",
    TEXT_ADJUST_THE_CROP_AREA: "Adjust the crop area",
    TEXT_PREVIEW: "Preview",
    TEXT_ROTATE_IMAGE: "Rotate Image",
    BUTTON_DIALOG_DISCARD: "Discard",
    TEXT_DIALOG_TITLE: "Discard Changes",
    TEXT_DIALOG_MESSAGE: "Are you sure you want to discard the changes you made?",
    BUTTON_TEXT_CANCEL: "Cancel",
    TEXT_ADD_PITURES_TO_PROJECTS:
      "Add pitures to projects on your timeline before creating a montage with them!"
    // TEXT_TUTORIAL_MONTAGE: "Montage",
    // BUTTON_MODAL_DELETE: "Delete",
    // BUTTON_MODAL_DELETE_NO: "No",
    // BUTTON_MODAL_DELETE_YES: "Yes",
    // BUTTON_MODAL_EDIT: "Edit",
    // BUTTON_MODAL_REPORT: "Report",

    // BUTTON_DIALOG_NO_THANKS: "No Thanks",
    // BUTTON_DONE: "DONE",
    // BUTTON_GOBACK: "GO BACK",
    // TEXT_CONTENT_REJECTED: "Content rejected",
    // TEXT_DIALOG_ALREADY_EXISTS_1: "Montage with",
    // TEXT_DIALOG_ALREADY_EXISTS_2: "name already exist!",
    //
    //
    // TEXT_DIALOG_WRITE_PICTURE: "Please, Select picture to write on that picture.",
    // TEXT_INAPPROPRIATE_IMAGE_1: "The text or picture you entered has been automatically",
    // TEXT_INAPPROPRIATE_IMAGE_2: "Please remove the content and try again.",
    // TEXT_INAPPROPRIATE_IMAGE_3: "Please remove the content and try again.",
    // TEXT_INAPPROPRIATE_IMAGE_4: "let us know.",
    // TEXT_INAPPROPRIATE_IMAGE_5: "let us know.",
    // TEXT_SNACKBAR_ADD_SONG: "Please add song.",
  },
  Tickets: {
    BUTTON_TEXT_ADD_TICKET: "Add Ticket",
    BUTTON_TEXT_CANCEL: "Cancel",
    BUTTON_TEXT_OK: "OK",
    BUTTON_TEXT_REPORT: "Report",
    BUTTON_TEXT_SELECT_TICKETS: "Select Tickets",
    BUTTON_TEXT_SELECT_TICKETS_TO_SHARE: "Select Tickets to Share",
    // BUTTON_TEXT_TUTORIAL: "Tutorial",
    TEXT_DELETE_TICKETS_DESC: "Are you sure you want to delete this tickets?",
    TEXT_DELETE_TICKETS_TITLE: "Delete Tickets",
    TEXT_EXPIRED_SHARED_TICKET_ALERT:
      "This ticket will not be shared with others because it has expired.",
    TEXT_EXPIRED_TICKET_ALERT: "This Ticket has expired.",
    TEXT_MY_TICKETS: "MY TICKETS",
    TEXT_NO: "NO",
    TEXT_NO_TICKETS: "No tickets.",
    TEXT_NO_TICKETS_PLACEHOLDER: "You don't have any tickets yet.",
    TEXT_NO_TICKETS_SHARED_PLACEHOLDER: "No tickets have been shared with you yet.",
    TEXT_REMOVE_TICKETS_DESC: "Are you sure you want to remove tickets shared with you?",
    TEXT_REMOVE_TICKETS_TITLE: "Remove Tickets",
    TEXT_SEARCH_MY_TICKETS: "Search my tickets",
    TEXT_SEARCH_SHARED_TICKETS: "Search tickets shared with me",
    // TEXT_SELECTED: "selected",
    // TEXT_SHARED_SNACKBAR: "Your Tickets have been shared.",
    TEXT_SHARED_TICKET_ALERT:
      "This Ticket has been shared. People with access can view your Ticket and any changes you make to it.",
    TEXT_SHARED_WITH_ME: "SHARED WITH ME",
    // TEXT_TAP_ANYWHERE_TO_CONTINUE: "Tap anywhere to continue",
    TEXT_TICKETS: "Tickets",
    // TEXT_TUTORIAL_INDICATORS:
    //   "Watch for these indicators to signify when your ticket expires or shared with other users",
    // TEXT_TUTORIAL_SHARE_INSTRUCTION:
    //   "Once the tickets are created, click and hold to select and share multiple tickets at a time This icon indicates that the ticket has been shared",
    // TEXT_TUTORIAL_SHARED_TAB:
    //   "Any tickets that are shared with you are seen in the SHARED WITH ME tab",
    // TEXT_TUTORIAL_TICKETS_DESC: "Where you can save and share licenses that you have with others",
    // TEXT_YES: "Yes",
    // TEXT_ADD_FRONT_IMAGE: "Please add the front image of your ticket.",
    TEXT_ADD_TICKET: "Add Ticket",
    TEXT_ABOUT: "ABOUT",
    // TEXT_CANCEL: "Cancel",
    // TEXT_CHOOSE_FROM_GALLERY: "Choose from gallery",
    // TEXT_CONTENT_REJECTED_BODY_FIRST:
    //   "The text or picture you entered has been automatically identified as inappropriate.",
    // TEXT_CONTENT_REJECTED_BODY_SECOND: "Please remove the content and try again.",
    // TEXT_CONTENT_REJECTED_BODY_THRID: "If you believe this is a mistake,",
    // TEXT_CONTENT_REJECTED_TITLE: "Content rejected",
    // TEXT_DELETE: "DELETE",
    TEXT_DELETE_DIALOG_DESC: "Are you sure you want to delete this ticket?",
    TEXT_DELETE_DIALOG_TITLE: "Delete Ticket",
    TEXT_REMOVE_TICKETS_TITLE: "Remove Tickets",
    // TEXT_DISCARD: "Discard",
    // TEXT_DISCARD_DIALOG_DESC: "Are you sure you want to discard the changes you made?",
    // TEXT_DISCARD_DIALOG_TITLE: "Discard Changes",
    TEXT_EDIT_TICKET: "Edit Ticket",
    TEXT_EXPIRING_DATE_OPTIONAL: "Expiring Date (optional)",
    TEXT_EXPIRY_DATE: "Expiry Date",
    // TEXT_GO_BACK: "GO BACK",
    TEXT_ID: "ID #",
    TEXT_ID_OPTIONAL: "ID # (optional)",
    TEXT_ISSUED_BY: "Issued By",
    TEXT_ISSUED_DATE: "Issued Date",
    // TEXT_ISSUED_DATE_REQUIRED: "Issued Date is a required field.",
    // TEXT_LET_US_KNOW: "let us know.",
    // TEXT_NO_THANKS: "No Thanks",
    TEXT_OPTIONAL: "optional",
    TEXT_TICKET_OPTIONAL: "Optional",
    // TEXT_SAVE: "SAVE",
    // TEXT_SELECT_ISSUED_BY: "Please add the company that issued your ticket.",
    // TEXT_SELECT_TICKET_TYPE: "Please select a ticket type.",
    // TEXT_START_DATE_BEFORE_END: "Start Date should be before the End Date.",
    TEXT_TICKET_INFO: "TICKET INFO",
    TEXT_TICKET_TYPE: "Ticket Type",
    TEXT_UPLOAD_BACK: "Upload back",
    TEXT_UPLOAD_FRONT: "Upload front",
    TEXT_EXPIRING: "Expires",
    TEXT_ISSUED_ON: "Issued On",
    TEXT_MESSAGE: "Message",
    TEXT_NO_BACK_IMAGE: "No back image",
    TEXT_NOT_YET_SHARED: "This Ticket has not been shared with anyone yet.",
    TEXT_OWNED_BY: "Owned By",
    TEXT_SHARE: "Share",
    TEXT_SHARED_WITH: "Shared With",
    TEXT_UNSHARE: "Unshare",
    TEXT_UNSHARE_CONFIRM: "Are you sure you want to unshare this ticket with",
    TEXT_VIEW_TICKET: "View Ticket",
    TEXT_ADD_CONTACTS_OR_EMAILS: "Add Contacts or emails",
    // TEXT_DISCARD_CHANGES_DESC: "Are you sure you want to discard the changes you made?",
    // TEXT_DISCARD_CHANGES_TITLE: "Discard Changes",
    // TEXT_DUPLICATE_EMAIL: "Please remove duplicate email addresses!",
    TEXT_INVALID_EMAIL: "Please enter a valid email address.",
    // TEXT_NOT_SIGNED_UP: "This person has not yet signed up for BuildID",
    TEXT_OK: "OK",
    BUTTON_MODAL_DELETE: "Delete",
    TEXT_TICKET_TYPE_FILTER_PLACEHOLDER: "Ticket Type",
    TEXT_TICKET_TYPE_ALL: "All",
    TEXT_TICKET_TYPE_VALID: "Valid",
    TEXT_TICKET_TYPE_EXPIRED: "Expired",
    TEXT_SORT_BY_FILTER_PLACEHOLDER: "Sort By",
    TEXT_SORT_BY_RECENT: "Recent",
    TEXT_SORT_BY_TYPE: "Type",
    TEXT_RECIPIENTS: "Recipients",
    TEXT_SEND_PDF_COPY: "Send PDF copy",
    TEXT_SHARE_TICKETS: "Share Tickets",
    TEXT_STOP_SHARING: "Are you sure you want to stop sharing your tickets with",
    TEXT_TICKETS_TO_SHARE: "Tickets to Share",
    TEXT_UNSHARE_TICKETS: "Unshare Tickets",
    TEXT_ADD_EMAIL_PLACEHOLDER: "Add Contact or Emails",
    TEXT_ADD: "Add"
  },
  Carpool: {
    TEXT_ADDRESS_DESCRIPTION: "Enter your address to find nearby people to ride share with.",
    TEXT_CARPOOL_HEADER: "Carpool",
    TEXT_CURRENT_SITE: "Current Site",
    TEXT_DIALOG_CONTENT_LINE1:
      "Your profile will be shared with nearby Builders that currently work on the same Site as you.",
    TEXT_DIALOG_CONTENT_LINE2: "Your address will not be shared.",
    TEXT_DIALOG_OK_BUTTON: "OK",
    TEXT_INTERESTED_IN_CARPOOL: "Interested in Carpool",
    TEXT_KM_AWAY: "km away",
    TEXT_MESSAGE: "Message",
    TEXT_MY_ADDRESS: "My Address",
    TEXT_NO_ADDRESS: "no address",
    TEXT_EDIT_ADDRESS_HEADER: "Edit Address",
    TEXT_ADDRESS_SEARCH: "Address search",
    TEXT_SEARCH_ADDRESS_PLACEHOLDER: "Search for your address",
    TEXT_OR_DEVIDER: "Or fill your address in below",
    TEXT_ADDRESS1_PLACEHOLDER: "Address 1",
    TEXT_ADDRESS2_PLACEHOLDER: "Address 2",
    TEXT_CITY_PLACEHOLDER: "City",
    TEXT_ALERT_DIALOG_BTN1: "Discard",
    TEXT_ALERT_DIALOG_BTN2: "No Thanks",
    TEXT_ALERT_DIALOG_DESC: "Are you sure you want to discard the changes you made?",
    TEXT_ALERT_DIALOG_TITLE: "Discard Changes",
    TEXT_COUNTRY_PLACEHOLDER: "Country",
    TEXT_POSTAL_PLACEHOLDER: "Postal Code / Zip",
    TEXT_STATE_PLACEHOLDER: "State / Province",
    TEXT_CONTACTS_WITHIN_5_KM: "Contacts within 5 km",
    TEXT_OTHERS_WITHIN_5_KM: "Others within 5 km",
    TEXT_SITE_MODAL_DESC:
      "You don't have any Sites yet. Go ahead and add one under My Sites first.",
    TEXT_NO_PEOPLE_AVAILABLE: "No people available for ride sharing.",
    TEXT_TUTORIAL_PAGE1_LINE1: "An easy way to find a ride with others",
    TEXT_TUTORIAL_PAGE1_LINE2: "going to the same place",
    TEXT_TUTORIAL_PAGE1_LINE3: "Tap anywhere to continue",
    TEXT_TUTORIAL_PAGE2_LINE1: "To have full access to Carpool, first toggle switch to interested",
    TEXT_TUTORIAL_PAGE3_LINE1: "Next, set your home address as well as the site",
    TEXT_TUTORIAL_PAGE3_LINE2: "you are working at",
    TEXT_TUTORIAL_PAGE3_LINE3:
      "Note: If you don't have a project/site on your profile, Carpool will not work",
    TEXT_TUTORIAL_PAGE4_LINE1:
      "If there is anybody within 5km going to the same site, they will show on the list for you to message",
    TEXT_NO_SITE_NAME: "No Site Name",
    TEXT_NO_SITES_AVAILABLE: "No sites Available",
    BUTTON_DISCARD: "Discard",
    TEXT_WE_COULDNT_DETERMINE_LOCATION:
      "We couldn't determine your location automatically. To find nearby carpoolers and provide accurate distance calculations, please either:",
    TEXT_TRY_LOCATION_AGAIN: "Try Location Again or Enter Postal Code Manually",
    TEXT_SHARE_YOUR_LOCATION_TO_SEE:
      "Share your location to see and be seen by BuildID carpoolers.",
    BUTTON_JOIN_CARPOOL: "Join carpool",
    TEXT_MY_SITE: "My Site",
    BUTTON_SELECT_SITE_FROM_PROFILE: "Select site from my profile",
    TEXT_No_ADDRESS: "No Address",
    TEXT_ONLY_SHOW_PEOPLE: "Only show people going to my site",
    TEXT_NEARBY_CARPOOLERS: "Nearby Carpoolers",
    TEXT_NO_NEARBY_MATCHES_RIGHT_NOW:
      "No nearby matches right now. More carpoolers may appear soon."
    // TEXT_CANCEL_SITE_MODAL: "Cancel",
    // TEXT_MORE_CANCEL: "Cancel",
    // TEXT_MORE_REPORT: "Report",
    // TEXT_MORE_TUTORIAL: "Tutorial",
  },
  PostalCodeDialogue: {
    TEXT_LOCATION: "Location",
    TEXT_ENTER_POSTAL_CODE: "Enter your postal code",
    BUTTON_APPLY: "Apply"
  },
  SiteListModal: {
    TEXT_SELECT_SITE: "Select Site",
    TEXT_NO_ADDRESS: "No Address",
    BUTTON_ADD_NEW_SITE: "Add new site",
    TEXT_NO_SITE_FOUND: "You don't have any site yet.",
    TEXT_ADD_SOME_SITE: "Go ahead and add one under My Site first."
  },
  LocationNeededModal: {
    TEXT_LOCATION_NEEDED: "Location Needed",
    TEXT_WE_COULDNT_DETERMINE_LOCATION:
      "We couldn't determine your location automatically. To find nearby carpoolers and provide accurate distance calculations, please either:",
    BUTTON_TRY_LOCATION_AGAIN: "Try Location Again",
    BUTTON_ENTER_POSTAL_CODE_MANUALLY: "Enter Postal Code Manually",
    TEXT_YOUR_EXACT_LOCATION_IS_NEVER_SHARED:
      "Your exact location is never shared - only approximate distance to other users",
    BUTTON_USE_PROFILE_LOCATION: "Use Location From Profile",
    BUTTON_NO_LOCATION_ON_PROFILE: "Set Location On Profile"
  },
  //carpool end
  Expenses: {
    TEXT_HEADER: "Expenses",
    TEXT_UNSENT: "UNSENT",
    TEXT_SENT: "SENT",
    BUTTON_ADD_EXPENSE: "ADD EXPENSE",
    BUTTON_SEND: "SEND",
    TEXT_DATE: "Date",
    TEXT_TOTAL_AMOUNT: "Total Amount",
    TEXT_PROJECT: "Project",
    TEXT_SELECT_PROJECT: "Select Project",
    TEXT_DESCRIPTION: "Description",
    TEXT_ADD_DESCRIPTION: "Add Description",
    TEXT_ENTER_DESCRIPTION: "Enter Description",
    TEXT_COMMENTS: "Comments",
    BUTTON_EDIT: "EDIT",
    TEXT_ADD_EXPENSES: "Add Expenses",
    TEXT_ADD_PICTURES: "ADD PICTURES",
    TEXT_EXPENSE_DATE: "Expense Date",
    TEXT_AMOUNT: "Amount",
    TEXT_DEFAULT_AMOUNT: "$ 0.00",
    TEXT_PROJECT_OPTIONAL: "Project (Optional)",
    TEXT_COMMENTS_OPTIONAL: "Comments (Optional)",
    BUTTON_SAVE: "SAVE",
    TEXT_EDIT_EXPENSES: "Edit Expenses",
    BUTTON_DELETE: "DELETE",
    TEXT_LAST_MODIFIED: "Last modified",
    TEXT_DELETE_EXPENSE: "Delete Expense",
    TEXT_SEND_EXPENSES: "Send Expenses",
    TEXT_EXPENSES_TO_SEND: "Expenses to Send",
    TEXT_VIEW_EXPENSES: "View Expenses",
    TEXT_EXPENSE_HAS_SENT: "This Expenses has been sent. Remember to resend if you edit!",
    TEXT_NO_EXPENSES_PLACEHOLDER: "You don't have any unsent Expenses.",
    TEXT_NO_SEND_EXPENSES_PLACEHOLDER: "You don't have any sent Expenses.",
    TEXT_MODAL_DELETE_EXPENSE_DESCRIPTION: "Are you sure you want to delete this Expense?",
    BUTTON_MODAL_DELETE_EXPENSE_NO: "No",
    BUTTON_MODAL_DELETE_EXPENSE_YES: "Yes",
    TEXT_CHOOSE_A_PROJECT: " Choose a Project",
    TEXT_PLEACEHOLDER: "Projects shown will only include sites at the company you work for",
    TEXT_NO_COMPANIES: "No Companies",
    TEXT_SELECT_PROJECT: "Select Project"
  },
  ResumeBuilder: {
    TEXT_RESUME_BUILDER_HEADER: "Resume",
    TEXT_NO_RESUME_LINE1: "There aren't any active Resumes right now.",
    TEXT_NO_RESUME_LINE2: "Please add new resume.",
    TEXT_ADD_RESUME: "Add Resume",
    TEXT_MENU_DELETE_BTN: "Delete",
    TEXT_CONFIRM_DELETE: "Confirm Delete",
    TEXT_DELETE_THIS_RESUME:
      "Are you sure you want to delete this resume? This action cannot be undone.",
    TEXT_RESUME_INFO_HEADER: "Resume Builder",
    TEXT_SHARERESUME_HEADER: "Share Resume",
    TEXT_ENTER_TITLE: "Enter Title of Resume",
    TEXT_SHARERESUME_TITLE: "Title",
    TEXT_SAVE_RESUME_HEADER: "Save Resume",
    TEXT_RESUME_TITLE: "Resume Title",
    TEXT_MY_RESUME: "e.g. My Resume",
    TEXT_SEND_RESUME: "SEND WITHOUT SAVING",
    BUTTON_BACK: "BACK",
    BUTTON_CREATE_RESUME: "Create Resume",
    TEXT_RESUME_INFO_SUBTITLE: "Choose information from your Profile to build a Resume.",
    TEXT_GENERATE_RESUME_BTN: "GENERATE RESUME",
    TEXT_NEXT_PAGE_BTN: "NEXT",
    TEXT_YOUR_INFO: "Your Info",
    TEXT_USER_TRADES_INFO: "Trades",
    TEXT_USER_EXPERIENCE_INFO: "Experience",
    TEXT_USER_EDUCATION_INFO: "Education",
    TEXT_USER_TICKETS_INFO: "Tickets",
    TEXT_USER_PRODUCT_INFO: "Products",
    TEXT_NO_TRADES_TO_PROFILE: "You don't have any Trades on your Profile yet.",
    TEXT_NO_COMPANY: "No Company",
    TEXT_NO_EXPERIENCE_TO_PROFILE:
      "You haven't added any Companies or Projects you've worked at to your Profile.",
    TEXT_RESUME_COUNT_ERROR: "Only 5 resumes can be saved!",
    TEXT_NO_EDUCATION_TO_PROFILE:
      "You haven't added any certifications, degrees, or training experiences to your Profile.",
    TEXT_NO_TICKETS_TO_PROFILE: "You haven't added any Tickets yet.",
    TEXT_EXPIRED_TICKET_ALERT: "This Ticket has expired.",
    TEXT_NO_PRODUCT_TO_PROFILE: "You haven't added any Products to your Profile yet.",
    TEXT_DELETE_SNACKBAR: "Resume deleted successfully.",
    TEXT_QUICKLY_GENERATE_AND: "Quickly generate and share your resume with others",
    TEXT_SAVE_UP_TO_5: "Save up to 5 resumes at a time",
    TEXT_TAP_ANYWHERE: "(Tap anywhere to continue)",
    TEXT_ENTER_THE_TITLE: "Enter the Title of Resume",
    TEXT_TITLE: "Title",
    TEXT_RECIPIENTS: "Recipients",
    TEXT_ADD_CONTACT_OR: "Add Contact or emails",
    // TEXT_HOME: "Home",
    // TEXT_MOBILE: "Mobile",
    // TEXT_OTHER: "Other",
    // TEXT_PERSONAL: "Personal",
    // TEXT_PRIMARY: "Primary",
    // TEXT_RECENT: "Recent",
    // TEXT_RECIPIENTS: "Recipients",
    // TEXT_SAVE: "SAVE",
    // TEXT_SHARE: "Share",
    // TEXT_TITLE: "Title",
    // TEXT_WORK: "Work",

    TEXT_RESUME_GENERATION_FAILED: "Resume generation failed",
    TEXT_RESUME_SHARED: "Your Resume has been shared.",
    TEXT_EMPTY_RECIPIENTS_ERROR: "Please add recipients to share resume.",
    TEXT_EMPTY_TITLE_ERROR: "Title cannot be empty.",
    TEXT_ENTER_VALID_ERROR: "Please enter a valid email address.",
    TEXT_ERROR_SAVING_PDF: "Something went wrong in saving title of pdf.",
    TEXT_ERROR_SENDING_RESUME: "Something went wrong while sending resumes.",
    TEXT_MODAL_CANCEL_BTN: "Cancel",
    TEXT_MODAL_TUTORIAL_BTN: "Tutorial",
    TEXT_RECENT_EMAIL: "Recent",
    TEXT_RECIPIENTS_TITLE: "Recipients",
    TEXT_RESUME_TITLE_PLACEHOLDER: "Title",
    TEXT_SAVE_RESUME_BTN: "SAVE",
    TEXT_SEARCH_EMAIL: "Add Contacts or emails",
    TEXT_TUTORIAL_MODAL: "After you are complete, enter a title and share!",
    TEXT_RESUME_MORE_CANCEL: "Cancel",
    TEXT_RESUME_MORE_TUTORIAL: "Tutorial",
    TEXT_TUTOTRIAL_LINE2_PAGE1: "Tap anywhere to continue",
    TEXT_ADD_RECIPIENTS_ERROR: "Please add recipients to share resume.",
    TEXT_CONTACT_SEARCH_PLACEHOLDER: "Add Contacts or emails",
    TEXT_INVALID_EMAIL_ERROR: "Please enter a valid email address.",
    TEXT_SHARERESUME_RECENT: "Recent",
    TEXT_SHARERESUME_RECIPIENTS: "Recipients",
    TEXT_SHARERESUME_SEND_BTN: "SEND",
    TEXT_SHARERESUME_SNACKBAR: "Something went wrong while sending resumes.",
    TEXT_SENDING: "Sending"
  },
  GlobalSearch: {
    TEXT_TYPE: "Type",
    TEXT_COMPANIES: "Companies",
    TEXT_MANUFACTURERS: "Manufacturers",
    TEXT_PRODUCTS: "Products",
    TEXT_TRADES: "Trades",
    TEXT_SITES: "Sites",
    TEXT_PROJECTS: "Projects",
    BUTTON_SHOW_MORE: "SHOW MORE",
    TEXT_ADVANCED: "Advanced",
    TEXT_LOCATION_TYPE_HERE_PLACEHOLDER: "Location - Type Here  ",
    TEXT_QUICK_LOCATION: "Quick Location",
    TEXT_SHOW_LESS_TRADES: "Show less trades",
    TEXT_SHOW_MORE_TRADES: "SHOW MORE TRADES",
    BUTTON_REPORT: "Report",
    TEXT_NO_RESULTS_FOUND: "No results found. Try again later or adjust your filters.",

    TEXT_TUTORIAL_FIFTH: "Use the advanced search for",
    TEXT_TUTORIAL_SIXTH: "location and trade to help narrow the search",

    TEXT_UNIVERSAL_SEARCH: "Universal Search",
    TEXT_TUTORIAL_FIRST: "Search through BuildIDs database of",
    TEXT_TUTORIAL_SECOND: "Companies, Manufacturers, Products and Trades",
    TEXT_TAP_ANYWHERE_TO_CONTINUE: "Tap anywhere to continue",

    TEXT_TUTORIAL_THIRD: "Search our system using keywords and/or",
    TEXT_TUTORIAL_FORTH: "selecting the type of item you are looking for."

    // TEXT_SEARCH_BUILDID: "Search BuildID",
    // TEXT_SEARCH_TITLE: "Search",

    // BUTTON_TUTORIAL: "Tutorial",
    // TEXT_SEARCH_BUILDID_PLACEHOLDER: "Search BuildID",
  },

  Settings: {
    TEXT_SETTINGS: "Settings",
    BUTTON_SEND_FEEDBACK: "SEND FEEDBACK",
    TEXT_ACCOUNT_INFO: "Account Info",
    TEXT_CHANGE_PASSWORD: "Change Password",
    TEXT_CLOSE_ACCOUNT: "Close Account",
    TEXT_GENERAL: "General",
    TEXT_TUTORIAL_VIDEOS: "Video Tutorial",
    TEXT_LANGUAGE_SETTINGS: "Language Settings",
    TEXT_NOTIFICATION_SETTINGS: "Notification Settings",
    TEXT_PRIVACY_POLICY: "Privacy Policy",
    TEXT_TERMS_AND_CONDITIONS: "Terms and Conditions",
    TEXT_CURRENT_LANGUAGE: "Current Language",
    TEXT_PROCEED: "PROCEED",
    TEXT_LANGUAGES: "Languages",
    TEXT_COMMENTS: "Comments",
    TEXT_CHAT_NOTIFICATIONS: "Chat Notifications",
    TEXT_CONNECTION_REQUEST: "Connection Request",
    TEXT_SUBMIT: "Submit",
    // Notification Categories
    TEXT_COMMUNICATION: "COMMUNICATION",
    TEXT_SAFETY_TICKETS: "SAFETY TICKETS",
    TEXT_PROFILE_UPDATES: "PROFILE UPDATES",
    TEXT_JOB_SEARCH_ALERTS: "JOB SEARCH ALERTS",
    TEXT_QUIZZES: "QUIZZES",
    // Notification Options - Communication
    TEXT_POST_COMMENTS: "Post Comments",
    TEXT_COMMENT_NOTIFICATIONS_DESC: "Get notified about post comments",
    TEXT_MESSAGES_GROUP_CONVERSATIONS: "Messages and group conversations",
    TEXT_CHAT_NOTIFICATIONS_DESC: "Messages and group conversations",
    TEXT_NEW_CONNECTION_REQUESTS: "New connection requests",
    TEXT_CONNECTION_REQUEST_DESC: "New connection requests",
    // Notification Options - Safety Tickets
    TEXT_TICKETS_EXPIRY: "Tickets Expiry",
    TEXT_TICKET_EXPIRATION_REMINDERS: "Ticket expiration reminders",
    // Notification Options - Profile Updates
    TEXT_PROFILE_UPDATES_LABEL: "Profile Updates",
    TEXT_PROFILE_UPDATES_DESC: "Profile updates and reminders",
    TEXT_WORK_EXPERIENCE_UPDATES: "Work Experience Updates",
    TEXT_WORK_EXPERIENCE_DESC: "Work experience changes",
    // Notification Options - Job Search
    TEXT_JOB_SEARCH_ALERTS_LABEL: "Job Search Alerts",
    TEXT_JOB_SEARCH_ALERTS_DESC: "Job search alert notifications",
    // Notification Options - Quizzes
    TEXT_QUIZ_NOTIFICATIONS: "Quiz Notifications",
    TEXT_QUIZ_NOTIFICATIONS_DESC: "Quiz and assessment notifications",
    // Notification Details - Comments
    TEXT_NOTIFICATION_DETAILS: "Notification Details",
    TEXT_COMMENT_NOTIFICATIONS_TIMING: "Comment Notifications",
    TEXT_COMMENT_NOTIFICATIONS_DETAIL:
      "You will receive notifications whenever someone comments on your posts, so you never miss an interaction.",
    // Notification Details - Chat
    TEXT_NEW_MESSAGE: "New Message",
    TEXT_NEW_MESSAGE_DETAIL:
      "You will receive a notification whenever someone sends you a new message, ensuring you stay informed.",
    TEXT_JOINED_PROJECT_GROUP: "Joined Project Group",
    TEXT_JOINED_PROJECT_GROUP_DETAIL:
      "You will be notified whenever someone joins a project-related chat group.",
    // Notification Details - Connection Request
    TEXT_IMMEDIATELY: "Immediately",
    TEXT_IMMEDIATELY_DETAIL: "Instant notification when someone sends you a connection request.",
    TEXT_THREE_DAYS_REMINDER: "3 Days Reminder",
    TEXT_THREE_DAYS_REMINDER_DETAIL: "Reminder to review pending connection requests after 3 days.",
    TEXT_WEEKLY_SUMMARY: "Weekly Summary",
    TEXT_WEEKLY_SUMMARY_DETAIL: "Weekly summary of new connections and pending requests.",
    // Notification Details - Safety Tickets
    TEXT_FIFTEEN_DAYS_BEFORE: "15 Days Before Expiration",
    TEXT_FIFTEEN_DAYS_BEFORE_DETAIL: "A reminder to ensure the renewal process is on track.",
    TEXT_THIRTY_DAYS_BEFORE: "30 Days Before Expiration",
    TEXT_THIRTY_DAYS_BEFORE_DETAIL:
      "An advance notification to help you plan and initiate the renewal process.",
    TEXT_ON_EXPIRATION_DATE: "On Expiration Date",
    TEXT_ON_EXPIRATION_DATE_DETAIL: "An alert notifying you that immediate renewal is required.",
    TEXT_TWO_WEEKS_AFTER_EXPIRATION: "Two Weeks After Expiration",
    TEXT_TWO_WEEKS_AFTER_EXPIRATION_DETAIL:
      "A follow-up reminder for tickets that have not yet been renewed.",
    // Notification Details - Profile Updates
    TEXT_DAY_ONE_AFTER_SIGNUP: "Day 1 After Sign-Up",
    TEXT_DAY_ONE_AFTER_SIGNUP_DETAIL:
      "Notification with profile completion tips and initial suggestions.",
    TEXT_FIFTEEN_DAYS_AFTER_SIGNUP: "15 Days After Sign-Up",
    TEXT_FIFTEEN_DAYS_AFTER_SIGNUP_DETAIL:
      "Follow-up reminder to complete or improve profile details.",
    TEXT_MONTHLY_REMINDER_FIRST: "Monthly Reminder (First Day of Month)",
    TEXT_MONTHLY_REMINDER_FIRST_DETAIL:
      "Monthly notification on the first day of the month to keep your profile updated.",
    // Notification Details - Work Experience
    TEXT_TWO_DAYS_AFTER_SIGNUP: "2 Days After Sign-Up",
    TEXT_TWO_DAYS_AFTER_SIGNUP_DETAIL: "Reminder to add or complete work experience details.",
    TEXT_SIXTEEN_DAYS_AFTER_SIGNUP: "16 Days After Sign-Up",
    TEXT_SIXTEEN_DAYS_AFTER_SIGNUP_DETAIL: "Encouragement to review and update work experience.",
    TEXT_MONTHLY_REMINDER_SECOND: "Monthly Reminder (Second Day of Month)",
    TEXT_MONTHLY_REMINDER_SECOND_DETAIL: "Monthly notification on the second day of the month.",
    // Notification Details - Job Search
    TEXT_NEW_JOB_ALERTS: "New Job Alerts",
    TEXT_NEW_JOB_ALERTS_DETAIL:
      "Receive notifications whenever new job postings match your saved preferences.",
    // Notification Details - Quizzes
    TEXT_DAILY_QUIZ_NOTIFICATIONS: "Daily Quiz Notifications",
    TEXT_DAILY_QUIZ_NOTIFICATIONS_DETAIL:
      "Get daily notifications for new quizzes and questions daily to earn builder bucks and test your knowledge.",
    // Notification Settings Buttons
    TEXT_SAVE_CHANGES: "Save Changes",
    TEXT_SAVING: "Saving...",
    TEXT_OK: "OK"
  },

  SendFeedback: {
    TEXT_SEND_FEEDBACK: "Send Feedback",
    TEXT_SEND_FEEDBACK_THANK_YOU: "Thank you! Your feedback helps us improve BuildID",
    TEXT_SEND_FFEDBACK_DESC_1:
      "Tell us about what you like about BuildID, or what we could be doing better.",
    TEXT_FEEDBACK: "Enter feedback", //
    TEXT_SEND_FFEDBACK_DESC_2: "Want to share more detailed feedback? Send us an email at",
    BUTTON_TEXT_SUBMIT: "SUBMIT" //
  },

  ChangePassword: {
    TEXT_CHARACTERS: "At least 6 characters",
    TEXT_NUMBER: "At least 1 number",
    TEXT_CAPITAL_LETTER: "At least 1 capital letter",
    TEXT_LOWER_LETTER: "At least 1 lowercase letter",
    TEXT_ENTER_CURRENT_PASSWORD: "Please Enter Current Password",
    TEXT_ENTER_NEW_PASSWORD: "Please Enter New Password",
    TEXT_ENTER_CONFIRM_PASSWORD: "Please Enter Confirm Password",
    TEXT_PASSWORD_NOT_MATCH: "New Password and Confirm Password do not match",
    TEXT_CHANGE_PASSWORD: "Change Password",
    TEXT_CURRENT_PASS_LABEL: "Current Password",
    TEXT_NEW_PASS_LABEL: "New Password",
    TEXT_PASSWORD: "Password",
    TEXT_PASS_STRENGTH: "Password strength",
    TEXT_CONFIRM_PASS_LABEL: "Confirm New Password",
    TEXT_STRONG_PASS: "Strong",
    TEXT_MEDIUM_PASS: "Medium",
    TEXT_WEAK_PASS: "Weak",
    TEXT_RESET_PASSWORD: "Reset Password",
    TEXT_PASS_MATCH: "Passwords Match",
    TEXT_PASS_NOT_MATCH: "Current password does not match!",
    TEXT_PASS_CHANGED: "Password Changed"
  },

  CloseAccount: {
    TEXT_CLOSE_ACCOUNT: "Close Account",
    TEXT_ABOUT_TO_DELETE_ACCOUNT: "You are about to delete your BuildID account",
    TEXT_SELECT_ALL: "Please select all of the following to confirm you understand.",
    TEXT_CHECKBOX_HEADER_1: "The following content will be permanently deleted:",
    TEXT_SUBHEADER_1:
      "Your Profile (including profile picture, contact information, work experience, and education items)",
    TEXT_SUBHEADER_2: "Builder Network connections",
    TEXT_SUBHEADER_3: "Timesheets, Expenses, Montages, and Resumes",
    TEXT_CHECKBOX_INSTRUCTION: "Select both checkboxes to confirm you understand.*",
    TEXT_CHECKBOX_HEADER_2:
      "The following content you have added to BuildID will be kept, but any association with you or your account will be removed:",
    TEXT_SUBHEADER_4: "Sites and Projects",
    TEXT_SUBHEADER_5: "Companies",
    TEXT_SUBHEADER_6: "Products",
    TEXT_SUBHEADER_7: "Posts, images, and comments",
    TEXT_SUBHEADER_8: "Chat messages",
    TEXT_DELETE_MY_ACCOUNT: "Delete My Account"
  },

  ProfileCard: {
    TEXT_ACCOUNTS: "Accounts",
    TEXT_REFER_SOMEONE_TO_BUILDID: "Refer someone to BuildID",
    TEXT_ACCOUNT_ACTIVITY_HEADER: "Account Activity",
    TEXT_PENDING_INVITATIONS: "Pending Invitations",
    TEXT_SETTINGS: "Settings",
    TEXT_TUTORIAL_VIDEOS: "Video Tutorial",
    TEXT_LOGOUT: "Log out",
    TEXT_PRIVACY_POLICY: "Privacy Policy",
    TEXT_TERMS_AND_CONDITIONS: "Terms & Conditions",
    TEXT_BUILDID: "BuildID"
  },

  JobPostings: {
    // Job Postings Feed (JobPostings.jsx)
    TEXT_JOB_POSTING_HEADER: "Job Postings",
    TEXT_SEARCH_JOBS: "Search Jobs...",
    TEXT_SELECT_LOCATION: "Select Location",
    TEXT_MY_JOBS: "My Jobs",
    TEXT_POST_A_JOB: "Post a job",
    TEXT_POSTED: "Posted:",
    TEXT_TODAY: "today",
    TEXT_ONE_DAY_AGO: "1 day ago",
    TEXT_DAYS_AGO: "days ago",
    TEXT_MORE: "more",
    TEXT_NO_JOB_POSTINGS_FOUND: "No Job postings found.",
    TEXT_SAVE_ALERT_MESSAGE: "Save this search as an alert?",
    // Job Card / Detail (ViewJobPosting.jsx)
    TEXT_DETAIL_MODAL_APPLY: "Apply For Job",
    KM_AWAY: "km away",
    TEXT_DETAIL_MODAL_DURATION_KEY: "Approx:",
    TEXT_DETAIL_MODAL_APPLIED_BTN: "APPLIED",
    TEXT_DETAIL_MODAL_APPLY_BTN: "Apply",
    TEXT_JOB_DETAILS: "Job Details",
    TEXT_DESCRIPTION: "Description",
    TEXT_NO_DESCRIPTION: "No description",
    TEXT_NO_DESCRIPTION_AVAILABLE: "No description available",
    TEXT_COMPANY: "Company",
    TEXT_FOLLOW: "Follow",
    TEXT_FOLLOWING: "Following",
    TEXT_YES_I_APPLIED: "Yes, I Applied",
    TEXT_DELETE_JOB_POSTING: "Delete Job Posting",
    TEXT_DELETE_JOB_POST_CONFIRM: "Are you sure you want to delete this job post?",
    TEXT_YES: "Yes",
    TEXT_NO: "No",
    TEXT_EXPIRES: "Expires",
    TEXT_VIA: "Via",
    TEXT_ALREADY_APPLIED: "Already Applied",
    TEXT_DID_YOU_APPLY: "Did you apply for this job?",
    TEXT_APPLY_NOW: "Apply Now",
    TEXT_DELETE: "Delete",
    TEXT_REPOST: "Repost",
    TEXT_APPLIED: "Applied",
    TEXT_APPLY_ON_WEBSITE: "Apply on website",
    TEXT_APPLY: "Apply",
    BUTTON_EMAIL: "Email",
    // Apply / Resume (ResumeList.jsx)
    TEXT_APPLY_TO: "Apply To",
    TEXT_CHOOSE_RESUME: "Choose a resume",
    TEXT_GENERATE_RESUME: "Generate Resume",
    TEXT_SUBMIT_APPLICATION: "Submit application",
    TEXT_A_RESUME_IS_REQUIRED: "A resume is required.",
    // Location Modal (LocationMenuModal.jsx)
    TEXT_LOCATION: "Location",
    TEXT_DISTANCE: "Distance",
    TEXT_EXTERNAL_WEBSITE: "External Website",
    TEXT_WEBSITE: "Website",
    TEXT_RECEIVED_APPLICANTS: "Receive applicants by:",
    TEXT_KM: "km",
    TEXT_SEARCH_LOCATION: "Search location",
    TEXT_PLEASE_SELECT_LOCATION: "Please select a location",
    BUTTON_APPLY: "APPLY",
    BUTTON_CLEARALL: "CLEAR ALL",
    // Filter Modal (FilterListModal.jsx)
    TEXT_FILTERS: "Filters",
    TEXT_SELECT_TRADES: "Select Trade(s)",
    TEXT_TYPE: "Type",
    TEXT_SEARCH_BY_KEYWORD: "Search by Keyword",
    TEXT_SEARCH_PLACEHOLDER: "Enter keyword to search ...",
    TEXT_CATEGORY_TITLE: "Title",
    TEXT_CATEGORY_COMPANY: "Company",
    TEXT_CATEGORY_PUBLISHER: "Publisher",
    TEXT_CATEGORY_TRADE: "Trade",
    TEXT_DONE: "Done",
    // My Jobs Modal (MyJobsModal.jsx)
    TEXT_MY_POSTING_BTN: "My Postings",
    TEXT_MY_RESUMES: "My Resumes",
    TEXT_JOB_ALERTS: "Job Alerts",
    // My Posting Page (MyJobPosting.jsx)
    TEXT_BACK_BUTTON: "Back",
    TEXT_INACTIVE: "Inactive",
    TEXT_ACTIVE: "Active",
    TEXT_NO_JOB_POSTS: "No job posts available",
    // Post a Job Modal (PostAJobModal.jsx)
    TEXT_TITLE: "Title",
    TEXT_ENTER_JOB_TITLE: "Enter job title",
    TEXT_SELECT_COMPANY: "Select company",
    TEXT_ADDITIONAL_INFORMATION: "Additional Information",
    TEXT_ADDITIONAL_INFORMATION_DESCRIPTION:
      "Add the Site and/or trade(s) you're hiring for to help others find your posting.",
    TEXT_SITE: "Site",
    TEXT_CHOOSE_SITE: "CHOOSE SITE",
    TEXT_TRADE: "Trade(s)",
    BUTTON_NEXT: "Next",
    BUTTON_PUBLISH: "Publish",
    TEXT_EMAIL_MISSING_PROFILE:
      "Email is missing in your profile. Please update your email to receive applications.",
    TEXT_PUBLISH_FAILED: "Failed to publish the job post. Please try again.",
    TEXT_NO_ADDRESS: "No address available",
    TEXT_SKILLS_PLACEHOLDER: "Add the skills and qualifications you are looking for (recommended)",
    TEXT_ENTER_WEBSITE_URL: "Enter website URL",
    TEXT_INVALID_WEBSITE_URL: "Please enter a valid website URL",
    TEXT_EMAIL_MISSING: "Email missing",
    // Job Alerts Modal (MyJobAlertModal.jsx)
    TEXT_MY_JOB_ALERTS: "My Job Alerts",
    TEXT_GET_NOTIFICATIONS: "Get notified when new jobs matching your search terms are posted.",
    TEXT_NO_JOB_ALERTS_FOUND: "No job alerts found.",
    BUTTON_ADD_ALERT: "Add Alert",
    TEXT_WITHIN: "Within",
    TEXT_KM: "km",
    TEXT_TRADE_LABEL: "Trade",
    TEXT_CATEGORY_LABEL: "Category",
    TEXT_DELETE_JOB_ALERT: "Delete Job Alert",
    TEXT_DELETE_JOB_ALERT_CONFIRM:
      "Are you sure you want to delete this job alert? This action cannot be undone.",
    TEXT_YES_DELETE: "Yes, Delete",
    TEXT_DELETING: "Deleting...",
    // Add Job Alert Modal (AddJobAlertModal.jsx)
    TEXT_ADD_JOB_ALERT_HEADER: "Add job alert",
    TEXT_CATEGORY_TYPE: "Category Type",
    TEXT_SEARCH_NAME: "Search Name",
    TEXT_ENTER_KEYWORD: "Enter keyword...",
    TEXT_JOB_TYPE: "Job Type",
    TEXT_TRADE_SELECT_ONE: "Trade (Select one) *",
    TEXT_SAVE_ALERT: "Save Alert",
    // Resume Reached Limit Modal (ResumeReachedLimitModal.jsx)
    TEXT_MAX_RESUMES_REACHED: "Maximum Resumes Reached",
    TEXT_MAX_RESUMES_BODY: "You've reached the maximum number of resumes allowed.",
    TEXT_MAX_RESUMES_DELETE_HINT: "Please delete an existing resume before creating a new one.",
    TEXT_CANCEL: "Cancel",
    // Resume Builder Modal (ResumeBuilderModal.jsx)
    TEXT_GENERATE_RESUME_QUICKLY: "Generate resumes in BuildID quickly apply to jobs.",
    RESUME_BUILDER: "Resume Builder"
  },

  BuySell: {
    // BuySell.jsx – Main screen
    TEXT_HEADER_BUY_SELL: "Buy / Sell /Trade",
    TEXT_HEADER_MY_LISTING_PAGE: "My Listing",
    TEXT_USING_CURRENT_LOCATION: "Using Current Location",
    TEXT_SEARCH_PLACEHOLDER: "Search listings by title...",
    TEXT_FILTER_BTN: "Filter",
    TEXT_MY_LISTINGS_BTN: "My Listings",
    TEXT_NO_LISTINGS_FOUND: "No listings found matching your criteria.",
    TEXT_CLEAR_ALL_FILTERS: "Clear all filters",
    TEXT_FOR_TRADE_BADGE: "For Trade",
    TEXT_NEARBY: "Nearby",
    TEXT_TRADE: "Trade",
    TEXT_RENTED_TAG: "Rented",
    TEXT_EXPIRY_PREFIX: "Exp.",
    TEXT_KMS_AWAY: "kms away",
    TEXT_REPORT_LISTING: "Report Listing",
    // MyListings.jsx
    TEXT_BACK_TO_MARKETPLACE: "Back to Marketplace",
    TEXT_POST_NEW_LISTING: "Post a New Listing",
    TEXT_NO_LISTINGS_YET: "You haven't posted any listings yet.",
    TEXT_CREATE_FIRST_LISTING: "Create Your First Listing",
    TEXT_ACTIVE_LISTINGS: "Active Listings",
    TEXT_EXPIRED_LISTINGS: "Expired Listings",
    TEXT_EXPIRED_CHIP: "Expired",
    TEXT_EXPIRES_IN: "Expires in",
    TEXT_DAYS: "days",
    TEXT_REPOST: "Repost",
    // AddListing.jsx
    TEXT_EDIT_LISTING_HEADER: "Edit Your Listing",
    TEXT_CREATE_NEW_LISTING_HEADER: "Create New Listing",
    TEXT_PHOTOS_LABEL: "Photos",
    TEXT_ADD_PHOTO: "Add Photo",
    TEXT_SELLING_TRADING_LABEL: "What are you selling / trading?",
    TEXT_SELLING_TRADING_PLACEHOLDER: "e.g. Concrete Mixer, Surplus Bricks",
    TEXT_PRICE_LABEL: "Price",
    TEXT_PRICE_PLACEHOLDER: "0.00",
    TEXT_FOR_TRADE_CHECKBOX: "For Trade",
    TEXT_DESCRIPTION_LABEL: "Description",
    TEXT_DESCRIPTION_PLACEHOLDER: "Describe what's included, the condition, etc.",
    TEXT_LOCATION_SITE_LABEL: "Location (Site)",
    TEXT_SELECT_SITE_BTN: "Select the site this item is located at",
    TEXT_UPDATE_LISTING_BTN: "Update Listing",
    TEXT_CREATE_LISTING_BTN: "Create Listing",
    TEXT_INVALID_IMAGE_ALERT: "Please select valid image files (JPEG, PNG, GIF, etc.).",
    // ItemDetailsModal.jsx
    TEXT_ITEM_DETAILS_HEADER: "Item Details",
    TEXT_DESCRIPTION_SECTION: "DESCRIPTION",
    TEXT_LOCATION_SECTION: "LOCATION",
    TEXT_MESSAGE_SELLER_BTN: "Message Seller",
    TEXT_OPEN_FOR_TRADE: "Open for Trade",
    TEXT_INDIVIDUAL_SELLER: "Individual Seller",
    TEXT_REPORT_ITEM: "Report Item",
    TEXT_SELECT_CONTACT_METHOD_TITLE: "Contact Seller",
    TEXT_SELECT_CONTACT_METHOD_SUBTITLE: "Choose how you want to contact the seller.",
    TEXT_EMAIL: "Email",
    TEXT_PHONE: "Phone",
    TEXT_CHAT: "Chat",
    // FilterOptions.jsx
    TEXT_FILTER_TITLE: "Filter Listings",
    TEXT_FILTER_SUBTITLE: "Select the type of listings you want to see.",
    TEXT_FOR_SALE: "For Sale",
    // SiteListForBuySell.jsx
    TEXT_CHOOSE_SITE_HEADER: "Choose a Site",
    TEXT_NO_SITES_FOUND: "No sites found.",
    TEXT_SITE_FOOTER_HINT: "Select the site where these items are currently located."
  },

  Chat: {
    TEXT_MESSAGES: "Messages",
    SEARCH_CONVERSATIONS: "Search conversations...",
    WELCOME_TO_MESSAGES: "Welcome to Messages",
    TEXT_CHAT_WITH_YOUR_CONTACT: "Connect and chat with your friends",
    TEXT_START_A_NEW_CHAT:
      "Select a conversation from the sidebar or start a new chat to begin messaging",
    TEXT_PLACEHOLDER_NO_DATA: "No Data Available",
    TEXT_HEADER_CHAT_SETTINGS: "Chat Settings",
    TEXT_TRANSLATION: "Translation",
    TEXT_TRANSALTE_MESSAGES: "Translate messages",
    TEXT_LANGUAGE_TRANSLATE_MASSAGE: "View messages in your preferred language when available.",
    TEXT_SELECT_LANGUAGE: "Select Language",
    TEXT_TYPE_TO_SEARCH: "Type to search...",
    SEARCH_LANGUAGE: "Search Language",
    TEXT_NO_LANGUAGES: "No languages available",
    TEXT_NEW_CHAT: "New Chat",
    PLACEHOLDER_TEXT_SEACRCH_USERS: "Search Users",
    TEXT_CANT_FIND_SOMEONE: "Can't find someone?",
    TEXT_INVITE_THEM: "Invite them",
    TEXT_MASSAGE:
      "Invite people to join BuildID and earn bonus BuilderBucks for each person that signs up!",
    TEXT_COPY_LINK: "Copy Link",
    TEXT_SHARE: "Share",
    BUTTON_REPORT: "Report",
    TEXT_SHOW_MEMBERS: "Show Members",
    TEXT_UNMUTE_NOTIFICATION: "Unmute Notifications",
    TEXT_MUTE_NOTIFICATION: "Mute Notifications",
    TEXT_LEAVE_CHAT: "Leave Chat",
    TEXT_VIEW_PROFILE: "View Profile",
    TEXT_DELETE_CHAT: "Delete Chat",
    TEXT_MASSAGE_CONFIMATION: "Are you sure you want to",
    TEXT_DESC_CONFIRMATION: "This action cannot be undone.",
    TEXT_PLACEHOLDER_MASSAGE: "Type a message",
    TEXT_IMAGES: "Images",
    TEXT_RECORD_AUDIO: "Record Audio",
    TEXT_VIDEO: "Video",
    TEXT_RECORD_A_MASSAGE: "Record a message",
    TEXT_SAVE: "Save",
    TEXT_SHARE_PROFILE: "Sharing Profile",
    TEXT_READY: "Ready",
    TEXT_MEDIA_PREVIEW: "Media Preview",
    TEXT_SEND: "Send"
  },
  BuilderNetwork: {
    TEXT_HEADER: "Builder Network",
    TEXT_SEARCH_MY_CONTACTS: "Search my Contacts",
    TEXT_LOOK_FOR_PEOPLE: "Search for People in BuildID",
    TEXT_ADD_CONTACT: "Add Contact",
    TEXT_SEARCH_PEOPLE: "Search people",
    TEXT_CANT_FIND_SOMEONE: "Can't find someone?",
    TEXT_INVITE_THEM: "Invite them",
    TEXT_MASSAGE:
      "Invite people to join BuildID and earn bonus BuilderBucks for each person that signs up!",
    TEXT_COPY_LINK: "Copy Link",
    TEXT_LINK_COPIED: "Link copied",
    TEXT_SHARE: "Share",
    TEXT_NO_DATA: "!!! NO DATA FOUND !!!",
    TEXT_CONNECT: "Connect",
    TEXT_REQUEST_SEND: "Request Sent",
    TEXT_ACCEPT: "Accept",
    TEXT_MESSAGES: "Messages",
    TEXT_CANCEL_REQUEST: "Cancel Request",
    TEXT_CONFIMATION: "Are you sure want to cancel request ?",
    TEXT_CANCEL: "Cancel",
    TEXT_OK: "Ok",
    TEXT_ME: "me",
    TEXT_SEND_MESSAGE: "Send Message",
    TEXT_DELETE_CONTACT: "Delete Contact",
    TEXT_DELETE: "Delete",
    TEXT_DELETE_CONTACT_CONF_TITLE: "Are you sure you want to delete this contact?",
    TEXT_DESC_CONFIRMATION: "This action cannot be undone."
  },
  TimeSheet: {
    TEXT_TIMESHEETS_TITLE: "Timesheets",
    TEXT_GOALS: "Goals",
    TEXT_ADD_GOAL: "Add Goal",
    TEXT_NO_MORE_GOALS: "No More Goals.",
    BUTTON_BACK: "BACK",
    BUTTON_EDIT: "EDIT",
    TEXT_EDIT_GOALS: "Edit Goals",
    TEXT_HIDE_COMPLETED_GOALS: "Hide Completed Goals",
    BUTTON_NEW_GOAL: "NEW GOAL",
    TEXT_GOAL_DESCRIPTION_FIRST: "Working towards an apprenticeship? Set up a Goal",
    TEXT_GOAL_DESCRIPTION_SECOND: "to track the hours from your Timesheets.",
    TEXT_EDIT_GOAL: "Edit Goal",
    TEXT_GOAL_NAME_PLACEHOLDER: "Name (eg. Electrical 1st Year)",
    TEXT_TOTAL_HOURS: "Total Hours",
    TEXT_OPTIONAL_CATEGORY_NOTE:
      "(Optional) You can use Categories to track specific items for your Goal",
    BUTTON_ADD_CATEGORY: "ADD CATEGORY",
    TEXT_CATEGORY_NAME: "Category Name",
    TEXT_UNTRACKED_HOURS: "Untracked Hours",
    TEXT_UNTRACKED_HOURS_FOR_CATEGORY: "Untracked hours for Category",
    TEXT_DIALOG_INFO:
      "Do you have hour credits that are not tracked in BuildID? Enter the number of hours here to count them towards this Goal.",
    TEXT_DIALOG_DELETE_GOALS_CATEGORIES: "Delete Goals/Categories",
    DIALOG_DELETE_DESCRIPTION:
      "Any progress for this Goal (and Categories) will be deleted. This cannot be undone. Are you sure you want to delete this Goal?",
    TEXT_ALL: "All",
    TEXT_SENT: "SENT",
    TEXT_UNSENT: "UNSENT",
    BUTTON_ADD_TIMESHEET: "ADD TIMESHEET",
    BUTTON_SEND: "Send",
    TEXT_IN_PROGRESS: "In progress",
    TEXT_EMPTY_TIMESHEETS_PLACEHOLDER: "You don't have any Timesheets.",
    TEXT_EXPORT_GOALS_SUMMARY: "Export Goals Summary",
    TEXT_REPORT: "Report",
    TEXT_NEW_TIMESHEET: "New Timesheet",
    TEXT_ADD_CLOCKIN: "Add ClockIn",
    TEXT_ADD_TIMESHEET: "Add Timesheet",
    EDIT_TIMESHEET: "Edit Timesheet",
    TEXT_TOTAL_CAPS: "TOTAL",
    TEXT_KM: "km",
    TEXT_MI: "mi",
    TEXT_TIMESHEET_DATE: "Timesheet Date",
    BUTTON_ADD_JOB: "ADD JOB",
    TEXT_DISCARD: "Discard",
    TEXT_DISCARD_DIALOG_DESC: "Are you sure you want to discard the changes you made?",
    TEXT_DISCARD_DIALOG_TITLE: "Discard Changes",
    TEXT_JOB_START: "Add a Job to get started with this Timesheet",
    TEXT_REQUIRED: "required",
    TEXT_DISTANCE: "Distance",
    TEXT_COMMENTS_PLACEHOLDER: "Comments (optional)",
    TEXT_ADD_PICTURES: "ADD PICTURES",
    TEXT_NO_COMPANY: "No Company",
    TEXT_CHOOSE_A_PROJECT: " Choose a Project",
    TEXT_PLEACEHOLDER: "Projects shown will only include sites at the company you work for",
    TEXT_EDIT_CLOCKIN: "Edit ClockIn",
    BUTTON_SAVE_CLOCKIN: "SAVE CLOCKIN/CLOCKOUT TIME",
    TEXT_IN: "In",
    TEXT_OUT: "Out",
    TEXT_CLOCK_IN: "CLock In",
    TEXT_CLOCK_OUT: "CLock Out",
    TEXT_MILAGE: "Milage",
    TEXT_GOAL_CREDIT_WARNING:
      "You can add a Goal or Category to this Job to count hour credits towards it. The total of all Goals/Categories’ time cannot exceed the Job’s time.",
    TEXT_VIEW_TIMESHEET: "View Timesheet",
    TEXT_LAST_MODIFIED: "Last modified:",
    TEXT_GOAL_LIST: "Goal List",
    BUTTON_GENERATE: "GENERATE",
    TEXT_PLACEHOLDER_NO_DATA: "No Data Available",
    TEXT_SEND_TIMESHEETS: "Send Timesheets",
    TEXT_TIMESHEETS_TO_SEND: "Timesheets to Send",
    BUTTON_REPORT: "Report",
    BUTTON_OK: "OK",

    BUTTON_DELETE: "DELETE",
    TEXT_SENT_WARNING: "This timesheet has been sent. Remember to resend if you edit!",
    TEXT_DELETE_TIMESHEET_TITLE: "Delete Timesheet",
    TEXT_DELETE_TIMESHEET_DESCRIPTION: "Are you sure you want to delete this Timesheet?"

    // TEXT_DELETE_JOB_POST_CONFIRMATION: "Delete Job Post",
    // TEXT_NAME: "Name",
    // TEXT_OPTIONAL: "optional",
    // TEXT_PLACEHOLDER: "Add emails",
    // TEXT_SELECT_GOALS: "Select one or more Goals to generate a PDF summary of your progress.",
    // TEXT_TOTAL: "Total",
    // BUTTON_CLOSE_MODAL: "CLOSE",
    // BUTTON_SELECT_TIMESHEETS_TO_SEND: "Select Timesheets to send",
    // TEXT_EMAIL_SUMMARY_INFO: "A summary of the selected Goal(s) will be emailed to your email.",
    // TEXT_SELECTED: "selected",
    // TEXT_SNACKBAR_INFO_PLACEHOLDER: "You can set up Goals in the more menu in the top right",
    // TEXT_TIMESHEET_SENT_NOTICE: "This timesheet has been sent. Remember to resend if you edit!",
    // BUTTON_CLOSE: "Close",
    // BUTTON_DELETE: "DELETE",
    // BUTTON_GO_BACK: "GO BACK",
    // BUTTON_SAVE: "Save",
    // TEXT_CHOOSE_FROM_GALLERY: "Choose from gallery",
    // TEXT_CONTENT_REJECTED_BODY_FIRST:
    //   "The text or picture you entered has been automatically identified as inappropriate.",
    // TEXT_CONTENT_REJECTED_BODY_SECOND: "Please remove the content and try again.",
    // TEXT_CONTENT_REJECTED_BODY_THRID: "If you believe this is a mistake,",
    // TEXT_CONTENT_REJECTED_TITLE: "Content rejected",
    // ",
    //
    // TEXT_ERROR_TOTAL: "The total of all Goals/Categories' time cannot exceed the Job's time.",
    // TEXT_LET_US_KNOW: "let us know.",
    // TEXT_NO: "NO",
    // TEXT_NO_THANKS: "No Thanks",
    // TEXT_YES: "Yes",
    // TEXT_ANOTHER_JOB_DESC: "Starting this job will automatically clock you out.",
    // TEXT_ANOTHER_JOB_TITLE: "You are currently clocked in to another Job.",
    // TEXT_DELETE_DESC: "This action cannot be undone.",
    // TEXT_GO_BACK: "Go back",
    // TEXT_JOB_DELETE_DESC: "Any logged time will be deleted. This cannot be undone.",
    // TEXT_JOB_DELETE_TITLE: "Are you sure you want to delete this Job?",
    // TEXT_ADD_EMAILS_PLACEHOLDER: "Add emails",
    // TEXT_INVALID_EMAIL: "Please enter a valid email address.",
    // TEXT_OK: "OK",
    // TEXT_RECENT: "Recent",
    // TEXT_RECIPIENTS: "Recipients",
    // TEXT_REMOVE_DUPLICATES: "Please remove duplicate email addresses!",
    // TEXT_TIMESHEETS_SENT_SUCCESS: "Your Timesheets have been successfully sent.",
    // BUTTON_DISCARD: "Discard",
    // BUTTON_NO_THANKS: "No Thanks",
    // DIALOG_DISCARD_DESCRIPTION: "Are you sure you want to discard the changes you made?",
    // DIALOG_DISCARD_TITLE: "Discard Changes",
    // DIALOG_ON_SAVE_CONFIRMATION:
    //   "Tracked hours for removed Categories will be deleted. This cannot be undone.Are you sure you want to continue?",
    // TEXT_NO_GOALS_ADDED: "You have not added any Goals yet."
  },
  Map: {
    TEXT_ALL_FILTER: "All Filter",
    TEXT_ACTIVE_SITES: "Active Sites",
    TEXT_SEARCH_BAR: "Search Map",
    TEXT_TOP_BUTTON_FOLLOWING: "Following",
    TEXT_TOP_BUTTON_MY_SITES: "My Sites",
    TEXT_TOP_BUTTON_UNNAMED: "Unnamed",
    MODAL_TYPE_SELECT_DEFAULT: "Default", //
    MODAL_TYPE_SELECT_HYBRID: "Hybrid", //
    MODAL_TYPE_SELECT_SATELLITE: "	Satellite", //
    MODAL_TYPE_SELECT_TERRAIN: "Terrain", //
    TEXT_NO_LOCATION_FIRST_TEXT: "There are",
    TEXT_NO_LOCATION_SECOND_TEXT: "item(s) you added that need action from you.", //
    TEXT_NO_LOCATION: "No Location",
    TEXT_NO_LOCATION_SITE_ALERT:
      "This Site will not be visible to others until a location is added.",
    TEXT_NO_LOCATION_SITE_INFO:
      "The following sites are missing a location. If you know where they  are, add it here",
    TEXT_ADD_LOCATION: "Add Location",
    TEXT_DELETE_SITE: "Delete Site",
    BUTTON_ADD_PROJECT: "Add Project",
    TEXT_ADD_SITE_NAME: "Add Site Name",
    TEXT_ENTER_SITE_NAME: "Enter Site name",
    TEXT_DELETE_SITE_ALERT: "Are you sure you want to delete this site?",
    TEXT_DELETE_SITE_DESC_ALERT: "This action cannot be undone.",
    BUTTON_DELETE: "DELETE",
    TEXT_REPORT: "Report"
  },
  SiteDetail: {
    DESCRIPTION_SEE_MORE: "SEE MORE",
    TEXT_ACTIVE: "Active",
    TEXT_ADD_DESCRIPTION: "Add Description",
    TEXT_ADD_DESCRIPTION_CAPS: "ADD DESCRIPTION",
    TEXT_ADD_LOCATION: "Add Location",
    TEXT_ADD_NEW_SITE: "ADD NEW SITE",
    TEXT_ADD_PROJECT_CAPS: "ADD PROJECT",
    TEXT_ADD_SITE_LOCATION: "ADD SITE LOCATION",
    TEXT_ADD_SITE_NAME_CAPS: "ADD SITE NAME",
    TEXT_ADD_SITE_NAME_STATEMENT:
      "Do you know the name of this site? Add it now to help others find it.",
    TEXT_ADD_TO_PROFILE: "Add to profile",
    TEXT_CHOOSE: "CHOOSE",
    TEXT_DELETE_SITE: "Delete Site",
    TEXT_DROPPED_PIN: "Dropped Pin",
    TEXT_ENTER_DESCRIPTION: "Enter Description",
    TEXT_FLAG_ACTIVE: "Flag as Active",
    TEXT_FOLLOW_ALL_CAPS: "FOLLOW ALL",
    TEXT_FOLLOWING_ALL_CAPS: "FOLLOWING ALL",
    TEXT_NEW_DESCRIPTION: "Add New Description",
    TEXT_NO_LOCATION: "No Location",
    TEXT_NO_PROJECTS_AT_LOCATION: "No Projects have been added to this location",
    TEXT_OTHERS_DESCRIPTIOJN: "Other Descriptions",
    TEXT_REPORT: "Report",
    TEXT_SITE_NOT_VISIBLE_MESSAGE:
      "This Site will not be visible to others until a location is added.",
    TEXT_UNNAMED_SITE: "Unnamed Site",
    TEXT_UNFOLLOW_PROJECT_SITE_DETAIL_ALERT: "Are you sure you want to unfollow this Site Page",
    TEXT_DELETE_SITE_ALERT: "Are you sure you want to delete this site?",
    TEXT_DELETE_SITE_DESC_ALERT: "This action cannot be undone.",
    BUTTON_DELETE: "DELETE",
    TEXT_YES: "YES",
    TEXT_SITE_DETAIL_PROJECTS: "Project(s)",
    TEXT_COMPANIES: "Companies",
    TEXT_PRODUCTS: "Products",
    TEXT_PROJECTS: "Projects",
    TEXT_SERVICES: "Services",
    TEXT_JOB_POSTINGS: "Job Postings",
    TEXT_ADD_COMPANY: "Add Company",
    TEXT_ADD_PRODUCT: "Add Product",
    TEXT_NO_RESULTS_FOUND: "No results found.",
    TEXT_NO_COMPANIES_ADDED_YET: "No companies added yet",
    TEXT_NO_PRODUCTS_ADDED_YET: "No products added yet",
    TEXT_FOLLOW_ALL: "Follow all",
    TEXT_FOLLOWING_ALL: "Following all",
    TEXT_NO_ROLE: "No Role",
    TEXT_YES: "Yes",
    TEXT_ADD_PROJECT: "Add Project",
    TEXT_FOLLOW_ALERT: "Do you want to follow all products?",
    TEXT_UNFOLLOW_ALERT: "Do you want to unfollow all products?",
    TEXT_FOLLOW_ALERT_PROJECT: "Do you want to follow all project?",
    TEXT_UNFOLLOW_ALERT_PROJECT: "Do you want to unfollow all project?",
    TEXT_NO_PROJECT_ADDED_YET: "No project added yet",
    BUTTON_ADD_WEBSITE: "Add Website",
    TEXT_ADD_PICTURE: "Add Picture"
  },
  SelectOption: {
    FAB_TEXT_ADD_SITE: "Add Site",
    FAB_TEXT_PIN_MY_LOCATION: "Pin my location",
    TEST_SELECT_IMAGE: "Select Image",
    TEXT_SELECT_OPTION: "Select Option"
  },
  AddSite: {
    BUTTON_CHANGE_LOCATION: "CHANGE LOCATION",
    BUTTON_CHOOSE_LOCATION: "CHOOSE LOCATION",
    BUTTON_SAVE: "Save",
    TEXT_ACTIVE_SITE: "Active Site",
    TEXT_ADD_SITE: "Add Site",
    TEXT_ADDRESS: "Address",
    TEXT_APARTMENT_SUITE_ETC_PLACEHOLDER: "Apartment, suite, etc.",
    TEXT_CITY: "City",
    TEXT_COUNTRY: "Country",
    TEXT_ZIP_CODE_LABEL: "ZIP Code",
    TEXT_DESCRIPTION_PLACEHOLDER: "Description (optional)",
    TEXT_POSTCODE: "Postcode",
    TEXT_PROVINCE: "Province",
    TEXT_SITE_NAME_PLACEHOLDER: "Site Name",
    TEXT_SUGGESTED: "Suggested"
  },

  AddAddress: {
    TEXT_ADD_ADDRESS_TITLE: "Add Address", //
    TEXT_SELECT_COUNTRY: "Select Country", //
    TEXT_ADDRESS: "Address", //
    TEXT_APARTMENT: "Apartment",
    TEXT_CITY_PLACEHOLDER: "City", //
    TEXT_PROVIENCE: "Province", //
    TEXT_POSTAL_CODE: "Postal Code", //
    TEXT_STATE: "State",
    TEXT_APARTMENT_SUITE_ETC: "Apartment, suite, etc",
    TEXT_POSTCODE: "Postcode",
    TEXT_ZIP_CODE_LABEL: "ZIP Code"
  },

  AddContactInfo: {
    TEXT_ADD_CONTACT_INFO_TITLE: "Add Address & Contact",
    TEXT_CONTACT_PERSON: "Contact Person",
    TEXT_CONTACT_PHONE: "Contact Phone",
    TEXT_CONTACT_EMAIL: "Contact Email"
  },

  AddAnotherNameModal: {
    TEXT_ADD_ANOTHER_NAME: "Add Another Name",
    BUTTON_CANCEL: "Cancel",
    BUTTON_SUBMIT: "Submit"
  },

  AddCompanyModal: {
    TEXT_ADD_COMPANY_LABEL: "Add Companies and Manufacturers",
    TEXT_COMPANY_NAME: "Company or Manufacturer Name", //
    BUTTON_ADD: "Add", //
    TEXT_EXISTING_COMPANY: "Existing Companies", //
    BUTTON_VIEW: "VIEW" //
  },

  AddCompanyWithRole: {
    BUTTON_ADD: "Add", //
    TEXT_COMPANIES: "Companies", //
    TEXT_ROLE: "Role",
    TEXT_SELECT_ROLE_OPTIONAL: "Select Role (optional)",
    TEXT_NEW_ROLE: "New Role",
    BUTTON_CANCEL: "Cancel", //
    BUTTON_SAVE: "SAVE",
    TEXT_COMPANY_NAME: "Company Name",
    TEXT_SUBMIT: "Submit"
  },

  AddExperience: {
    TEXT_CHANGE_END_DATE: "Please Change End Date or unchecked present.",
    TEXT_START_DATE_END_DATE_TITLE:
      "Start Date should be before the End Date, or click I currently work here if you are still working on this site.",
    TEXT_START_DATE_OR_UNCHECKED_PRESENT: "Please select Start Date or unchecked present.", //
    TEXT_ROLE_NOT_PRESENT: "This company role not present",
    TEXT_SELECT_START_DATE: "Please select start date",
    TEXT_OUTSIDE_TIMEFRAME_1: "This Project's timeframe is outside of your time at",
    TEXT_UPDATE_TIMEFRAME_2: "Would you like to update the timeframe?",
    TEXT_PROJECT_TIMEFRAME_1: "This Project's timeframe is outside of",
    TEXT_CORRECT_TIMEFRAME_2: "timeframe. Please, select correct timeframe.",
    BUTTON_CANCEL: "Cancel", //
    TEXT_UPDATE: "UPDATE", //
    TEXT_PROMPT_DELETE_EXPERIENCE: "Delete Experience", //
    TEXT_PROMPT_DESC: "Are you sure you want to delete this Experience from your Profile?", //
    BUTTON_MODAL_DELETE_YES: "Yes", //
    BUTTON_MODAL_DELETE_NO: "No", //
    TEXT_DISCARD_CHANGES: "Discard Changes", //
    TEXT_WANT_TO_LEAVE_PAGE:
      "This Site has not been saved to your Profile yet. Are you sure you want to leave this page?",
    BUTTON_DISCARD: "Discard", //
    BUTTON_GOBACK: "Go Back", //
    TEXT_EDIT_EXPERIENCE_PROFILE: "Edit experience on profile",
    TEXT_ADD_EXPERIENCE_PROFILE: "Add experience to profile",
    TEXT_SITE_PROJECT: "Site/Project", //
    TEXT_MY_INFORMATION: "My Information",
    TEXT_COMPANY: "Company", //
    TEXT_START_DATE: "Start Date", //
    TEXT_MONTH_YEAR: "Month - Year",
    TEXT_COMPANY_ROLE: "Company Role",
    TEXT_END_DATE: "End Date", //
    BUTTON_ADD: "Add", //
    TEXT_TITLE_ROLE: "Title/Role",
    TEXT_TRADE: "Trade", //
    TEXT_LABEL_DESCRIPTION: "Description", //
    TEXT_PRESENT: "Present", //
    TEXT_PRODUCTS: "Products", //
    TEXT_MATERIAL_INSTRUCTION:
      "You can add any Materials or Tools you used while working on this Project. They'll also appear on your Profile.",
    TEXT_UPDATE_INFORMATION_INSTRUCTION:
      "You can update this information from the My Sites tab or on your Profile.",
    TEXT_THIS_INFORMATION_CAN:
      "This information can be updated at anytime through your profile, or the Project page (My Experience tab).",
    TEXT_PRODUCTS_IN_PROJECT: "Products",
    TEXT_NO_OPTIONS: "No Options",
    TEXT_NO_LOCATION_SITE_ALERT_IN_PROJECT:
      "This Site will not be visible to others until a location is added."
  },
  AddManufactureModal: {
    TEXT_ADD_MANUFACTURER: "Add Manufacturer", //
    TEXT_MANUFACTURER_PLACEHOLDER: "Manufacturer Name", //
    BUTTON_ADD: "Add", //
    TEXT_EXISTING_MANUFACTURES: "Existing Manufacturers", //
    BUTTON_VIEW: "VIEW" //
  },

  AddPhoneNumberModal: {
    TEXT_PHONE_CODE: "Phone Code",
    TEXT_PHONE_NUMBER_PLACEHOLDER: "Phone Number", //
    TEXT_ADD_PHONE_NUMBER: "Add Phone Number" //
  },

  AddTradeModal: {
    TEXT_SELECT_TRADE: "Select Trade", //
    TEXT_SEARCH_FOR_TRADE: "Search for trade", //
    TEXT_NO_RESULTS_FOUND: "No results found. Try again later or adjust your filters.", //
    BUTTON_CLOSE: "Close", //
    BUTTON_SAVE: "SAVE" //
  },

  AddWebsiteModal: {
    BUTTON_ADD_WEBSITE: "ADD WEBSITE", //
    TEXT_INPUT_LABEL_WEBSITE: "Website", //
    TEXT_ENTER_VALID_URL: "Enter a vaild website url",
    TEXT_INVALID_URL: "Invalid URL"
  },

  MemberList: {
    TEXT_CONNECT_REQUEST: "Connect Request", //
    TEXT_REQUESTED_CONNECT_WITH_YOU: "has requested to Connect you.", //
    TEXT_MEMBERS: "Members",
    BUTTON_CONNECT: "Connect", //
    TEXT_MESSAGES: "Messages", //
    TEXT_REQUEST_SEND: "Request Sent", //
    TEXT_WORKED_ON: "Worked On", //
    TEXT_ME: "(me)", //
    TEXT_NO_DATA: "!!! NO DATA FOUND !!!" //
  },

  NoSuchPage: {
    TEXT_NO_SUCH_PAGE_TITLE: "Looking for something?",
    TEXT_NO_SUCH_PAGE_SUBHEADING_1:
      "We're sorry. The Web address you entered is not a functioning page on our site.",
    TEXT_NO_SUCH_PAGE_SUBHEADING_2: "Back to Home Page"
  },

  RequestTradeModal: {
    TEXT_REQUEST_A_TRADE: "Request a Trade",
    TEXT_TRADE: "Trade",
    BUTTON_CANCEL: "Cancel",
    BUTTON_SUBMIT: "Submit"
  },

  ReviewInputModal: {
    TEXT_WRITE_A_REVIEW: "Write a Review", //
    TEXT_WRITE_ABOUT_PRODUCT: "What do you think about this product? (optional)",
    BUTTON_CANCEL: "Cancel", //
    BUTTON_POST: "Post" //
  },

  SendInChatModal: {
    BUTTON_CANCEL: "Cancel", //
    TEXT_NEW_CHAT: "New Chat", //
    TEXT_AND: "and", //
    TEXT_OTHER: "Others", //
    TEXT_NO_DATA: "!!! NO DATA FOUND !!!" //
  },

  AddProductModal: {
    TEXT_ADD_PRODUCT: "Add Product", //
    TEXT_TO_MANUFACTURER: "to Manufacturer",
    TEXT_TO_COMPANY: "to Company",
    TEXT_TO_TRADE: "to Trade",
    TEXT_PRODUCT_NAME: "Product Name", //
    TEXT_MANUFACTURER_HEADER: "Manufacture",
    TEXT_MANUFRACTURER_OPTIONAL: "Manufacturer (optional)", //
    TEXT_TYPE: "Type", //
    TEXT_NEW_PRODUCT: "New Product",
    BUTTON_ADD: "Add",
    TEXT_NO_MANUFACTURER: "(no Manufacturer)", //
    TEXT_EXISTING_PRODUCTS: "Existing Products", //
    BUTTON_VIEW: "VIEW", //
    TEXT_PRODUCTS_ARRAY_TOOLS: "Tools",
    TEXT_PRODUCTS_ARRAY_MATERIALS: "Material"
  },

  AddProducts: {
    TEXT_ADD_PRODUCT_TO_COMPANY: "Add Product to Company", //
    TEXT_PRODUCT_NAME_HERE: "Product Name Here",
    TEXT_MANUFRACTURER_OPTIONAL: "Manufacturer (optional)", //
    TEXT_PRODUCTS_ARRAY_TOOLS: "Tools", //
    TEXT_PRODUCTS_ARRAY_MATERIALS: "Material", //
    TEXT_NEW_PRODUCT: "New Product", //
    BUTTON_ADD: "Add", //
    TEXT_EXISTING_PRODUCTS: "Existing Products", //
    BUTTON_VIEW: "VIEW", //
    TEXT_NO_RESULTS_FOUND: "No results found. Try again later or adjust your filters." //
  },

  AddProject: {
    TEXT_SELECT_VALID_IMAGE: "Please select valid image files",
    TEXT_ENTER_VALID_URL_FORMAT: "Please enter a vaild URL format",
    TEXT_PROJECT_NAME_SAME_AS_SITE: "The Project Name will also be used as the Site Name.",
    TEXT_ADD_PROJECT: "Add Project", //
    TEXT_ADD_PICTURES: "ADD PICTURES", //
    TEXT_SITE_NAME_PLACEHOLDER: "Site Name", //
    TEXT_NO_LOCATION: "No Location", //
    TEXT_CHOOSE_SITE: "CHOOSE SITE",
    TEXT_OR: "OR", //
    TEXT_PROJECT_NAME_REQUIRED: "Project Name (required)",
    TEXT_TYPE: "Type", //
    TEXT_INPUT_LABEL_WEBSITE: "Website", //
    TEXT_ACTIVE_PROJECT: "Active Project",
    TEXT_ADD_TO_MY_PROFILE: "Add to my profile",
    TEXT_DESCRIPTION: "Description", //
    BUTTON_TEXT_OK: "OK"
  },

  ChooseLocation: {
    TEXT_CHOOSE_LOCATION: "Choose Location", //
    TEXT_SEARCH_MAP: "Search map", //
    BUTTON_USE_CURRENT_LOCATION: "Use Current location",
    BUTTON_USING_CURRENT_LOCATION: "Using Current location"
  },

  MapModal: {
    TEXT_SELECT_LOCATION: "Select Location",
    TEXT_CHOOSE_PROJECTS: "Choose Projects",
    TEXT_CHOOSE_SITE_ON_MAP: "Choose Site",
    TEXT_MAP: "Map"
  },

  ReportModal: {
    TEXT_REPORT_HEADING: "Is something wrong with this data?",
    TEXT_THIS_DATA_IS: "This data is:",
    TEXT_SUGGESTION: "Suggestion/Requests",
    TEXT_INCORRECT_INFO: "Incorrect Information",
    TEXT_OFFENSIVE: "Offensive or inappropriate",
    TEXT_SOMETHING_ELSE: "Something else",
    TEXT_COMMENTS: "Comments",
    BUTTON_CANCEL: "Cancel",
    BUTTON_REPORT: "Report",
    TEXT_YOUR_FEEDBACK_HAS_BEEN_SUBMITTED: "Your feedback has been submitted.",
    TEXT_OK: "Ok"
  },

  HomeTutorial: {
    TEXT_HOMEPAGE: "Homepage",
    TEXT_PAGE_ONE_SUBHEADER_ONE:
      "This will display all posts from contacts, and groups you follow.",
    TEXT_PAGE_TWO_SUBHEADER_TWO:
      "It will also display all your general details such as BuilderBucks and notifications.",
    TEXT_TUTORIAL_MODAL_ANYWHERE_BTN: "Tap anywhere to continue",
    BUTTON_ALL: "All",
    BUTTON_PROJECTS: "Projects",
    BUTTON_TRADES: "Trades",
    BUTTON_PRODUCTS: "Products",
    TEXT_FILTER_POSTS: "Filter Posts by these keywords",
    TEXT_PAGE_THREE_SUBHEADER: "Create a general post for all your contacts to see",
    TEXT_WHAT_DO_TALK_ABOUT: "What do you want to talk about?"
  },

  SitesTutorial: {
    TEXT_MY_SITES: "My Sites",
    TEXT_FOLLOWING: "Following",
    TEXT_UNNAMED: "Unnamed",
    TEXT_ACTIVE_SITES: "Active Sites",
    TEXT_MAP: "Map", //
    TEXT_PAGE_ONE_SUBHEADER: "Shows you where sites are located",
    TEXT_TUTORIAL_MODAL_ANYWHERE_BTN: "Tap anywhere to continue", //
    TEXT_PAGE_TWO_SUBHEADER_ONE: "Numbered Clusters are groupings of multiple sites.",
    TEXT_PAGE_TWO_SUBHEADER_TWO: "Individual sites are displayed with an ID Tag.",
    TEXT_PAGE_TWO_SUBHEADER_THREE:
      "Tap on either to get more information, follow a site, or add a site to your profile.",
    TEXT_PAGE_THREE_SUBHEADER_ONE: "Know of a site that isn't being shown?",
    TEXT_PAGE_THREE_SUBHEADER_TWO: "You can add it here.",
    TEXT_SEARCH_MAP: "Search map", //
    TEXT_PAGE_FOUR_SUBHEADER_ONE:
      "You can choose to explore the map or search for a specific site.",
    TEXT_PAGE_FOUR_SUBHEADER_TWO:
      "Use the 'My Sites' button to filter the map to just the sites you follow or have worked at.",
    TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_ONE: "A popup will appear when you tap on a site.",
    TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_TWO:
      "Here you can view the site details, and choose to follow the site or add it to your profile.",
    TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_THREE: "Follow = Receive Site Updates",
    TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_FOUR: "Add to Profile = You have worked here",
    TEXT_PAGE_FIVE_SUBHEADER_SUBHEADER_FIVE: "Tap on the Site Name to go to the Site Page",
    BUTTON_FOLLOW: "Follow", //
    TEXT_ADD_TO_PROFILE: "Add to profile" //
  },

  TicketsTutorial: {
    TEXT_MY_TICKETS: "MY TICKETS", //
    TEXT_SHARED_WITH_ME: "SHARED WITH ME", //
    TEXT_TICKETS: "Tickets", //
    TEXT_TT_PAGE_ONE_SUBHEADER_ONE:
      "Where you can save and share licenses that you have with others", //
    TEXT_TUTORIAL_MODAL_ANYWHERE_BTN: "Tap anywhere to continue", //
    TEXT_TT_PAGE_TWO_SUBHEADER_ONE:
      "Any tickets that are shared with you are seen in the SHARED WITH ME tab",
    TEXT_TT_PAGE_THREE_SUBHEADER_ONE:
      "Watch for these indicators to signify when your ticket expires or shared with other users",
    TEXT_TT_PAGE_FOUR_SUBHEADER_ONE:
      "Once the tickets are created, click and hold to select and share multiple tickets at a time",
    TEXT_TT_PAGE_FOUR_SUBHEADER_TWO: "This icon indicates that the ticket has beem shared"
  },

  DashBoard: {
    TEXT_VIEW_PROFILE: "View Profile",
    TEXT_WHATS_NEW: "What's New",
    TEXT_NO_SITES_AVAILABLE: "No Sites Data Available",
    // NEW ABOVE

    TEXT_HI: "Hi,",
    TEXT_BUILDERBUCKS: "BuilderBucks",
    BUTTON_EARN_BUILDERBUCKS: "Earn BuilderBucks",
    TEXT_ANSWER_SUBMITTED: "Your answer was submitted.",
    TEXT_EARNED_BY_ANS: "Earned by answering this question.",
    BUTTON_LEARN_MORE: "Learn more",
    TEXT_NEARBY_SITES: "Nearby Sites",
    TEXT_ENABLE_LOCATION: "Enable location",
    TEXT_NO_LOCATION_PLACEHOLDER: "Share your location with BuildID to see Sites around you.",
    TEXT_VIEW_SITES_ON_MAP: "View sites on map",

    TEXT_EXPLORE_MORE_SITES: "Explore more Sites",
    TEXT_TIMESHEETS: "Timesheets",
    TEXT_JOBS: "Jobs",
    TEXT_TIME: "Time",
    TEXT_SEE_ALL: "See all",
    TEXT_NO_TIMESHEET_PLACEHOLDER:
      "Easily record your work hours and track progress towards goals.",
    TEXT_EXPENSES: "Expenses",
    TEXT_LOCATION_TEXT_1: "Location access denied.",
    TEXT_LOCATION_TEXT_2:
      "Please allow location permission in your browser settings and refresh the page.",
    TEXT_EXPENSES_PLACEHOLDER:
      "Never lose track of a receipt again! Manage your expenses by saving receipts, notes and costs.",

    TEXT_NO_EXPENSES_PLACEHOLDER: "You don't have any unsent Expenses.",
    TEXT_EARN_BUILDERBUCKS: "Earn BuilderBucks",
    TEXT_SETTINGS: "Settings",
    BUTTON_CANCEL: "Cancel",
    TEXT_BUILDER_BUCKS: "BuilderBucks",
    TEXT_GO_TO_PROFILE: "Go to Profile",
    BUTTON_OK: "OK",
    TEXT_ALERT_LOCATION_1: "Please allow location access in your browser.",
    TEXT_ALERT_LOCATION_2: "Location information is unavailable.",
    TEXT_ALERT_LOCATION_3: "The request to get user location timed out.",
    TEXT_ALERT_LOCATION_4: "An unknown error occurred.",

    TEXT_SURVEY_ASK_DESC:
      "Thank you for agreeing to take our survey at a later time.Please select the next time we ask?",
    TEXT_ONBOARDING_TITLE:
      "Add your contact information to your Profile so others can get in touch with you.",
    TEXT_TIMESHEET_PLACEHOLDER: "Easily record your work hours and track progress towards goals.",
    // TEXT_SHARE_LOCATION: "Share your location with BuildID to see Sites around you.",
    TEXT_PROGRESS_BAR_MODAL_TITLE: "Are you sure you want to hide the progress bar?",
    TEXT_FOLLOW_PROJECT: "Follow a Single Project that interests you",
    TEXT_SPEND_BUILDERBUCK: "Spend a Builderbuck (under rewards)",
    TEXT_SURVEY_TITLE: "Would you be interested in taking our",

    TEXT_ADD_CURRENT_TRADE: "Add your current trade",
    TEXT_WHEN_SHOULD_WE_ASK: "When Should We Ask ?",
    TEXT_ADD_EXPERIENCES: "Add to your Experiences",

    TEXT_ADD_EDUCATION: "Add Education",
    TEXT_NO_NEARBY_SITES: "No Nearby Sites",
    TEXT_ONE_TIME_SURVEY: "One Time Survey",
    TEXT_TIMESHEETS_TITLE: "Timesheets",
    BUTTON_MAYBE_LATER: "MAYBE LATER",

    TEXT_LATER_TODAY: "Later Today",
    TEXT_EXPENSES_TITLE: "Expenses",
    TEXT_NEXT_MONTH: "Next Month",
    TEXT_NEXT_WEEK: "Next Week",
    TEXT_TOMMORROW: "Tomorrow",
    BUTTON_SKIP: "Skip",
    BUTTON_NEVER: "NEVER",
    TEXT_NEVER: "Never",
    BUTTON_SURE: "SURE",
    TEXT_HI: "Hi",
    TEXT_FEEDBACK: "We would love to hear your feedback",
    BUTTON_GO_TO_MORE_FEATURES: "Go to more features",
    TEXT_QUESTION_OF_THE_DAY: "Question of the Day"
  },
  Survey_Dashboard_Web: {
    TEXT_LATER_TODAY: "Later Today",
    TEXT_TOMMORROW: "Tomorrow",
    TEXT_NEXT_WEEK: "Next Week",
    TEXT_NEXT_MONTH: "Next Month",
    TEXT_NEVER: "Never",
    TEXT_WOULD_YOU_LIKE_TO: "Would you be interested in taking our one time survey?",
    TEXT_WE_WOULD_LOVE_TO_HEAR_YOUR_FEEDBACK: "We would love to hear your feedback",
    BUTTON_SURE: "SURE",
    BUTTON_NEVER: "NEVER",
    BUTTON_MAYBE_LATER: "MAY be later",
    BUTTON_SAVE: "Save",
    TEXT_PLEASE_SELECT_THE_OPTION: "Please select the option",
    TEXT_THIS_IS_REQUIRED: "This is required"
  }
};

export { English };
